export const jobs = {
  // The job page, top down (tracker sj-30).
  page: {
    state: {
      done: "Done",
      current: "You are here",
      upcoming: "Later",
    },
    youAreHere: "You are here",
    nextStep: {
      title: "Next step",
      needsYou: "Needs you",
      changeStatusA11y: "Status: {{status}}. Change status",
      giveToSomeoneElse: "Give to someone else",
      nothingLeft: "Nothing left to do",
    },
    section: {
      what: "What to do",
      where: "Where",
      who: "Who and when",
      before: "Before you start",
      beforeAny: "Before any sub-job starts",
      work: "The work",
      subJobs: "Sub-jobs",
      costs: "Costs",
      finish: "When you finish",
      atTheEnd: "At the end",
      signOff: "Sign-off",
      report: "Report",
      activity: "Activity",
    },
    change: "Change",
    openReport: "Open report",
    meta: {
      doneOf: "{{done}} of {{total}}",
      updates_one: "1 update",
      updates_other: "{{count}} updates",
      estimate: "est {{amount}}",
    },
    summary: {
      nobodyYet: "Nobody yet",
      workDone: "Work done",
      signedOff: "Signed off",
      waitingSignOff: "Waiting for sign-off",
      reportLater: "Ready once the work is done",
      costsLater: "Added once the work starts",
      noCosts: "No costs recorded",
      signOffLater: "After the work is done",
    },
  },
  visits: {
    showMe: "Show me",
    title: "Visits",
    empty: "One trip so far. Plan another visit when the work needs more than one day.",
    visitNo: "Visit {{no}}",
    arrive: "I'm here",
    arrived: "Arrival recorded",
    move: "Move the visit",
    moveTitle: "Move visit {{no}}",
    moved: "Visit moved",
    notes: "Notes for the day",
    notesTitle: "Notes for visit {{no}}",
    notesMessage: "What was done on this visit?",
    notesSaved: "Notes saved",
    cancel: "Cancel the visit",
    cancelled: "Visit cancelled",
    add: "Plan a visit",
    addAnother: "Plan another visit",
    addTitle: "Plan a visit",
    addHint: "The same person comes back another day. The job is completed once, at the end.",
    added: "Visit planned",
    comeBack: "I need to come back",
    comeBackTitle: "I need to come back",
    comeBackHint: "Today's visit ends here and the next one is planned. The job stays open.",
    comeBackReason: "Why do you need to come back?",
    todayNotes: "What was done today (optional)",
    nextDay: "Next visit",
    comeBackConfirm: "Plan the next visit",
    comeBackSaved: "Next visit planned",
    comeBackBecause: "Coming back: {{reason}}",
    day: "Day",
    time: "Time",
    save: "Save",
    cancelSheet: "Cancel",
    photosHint: "Add photos for a visit to the job's activity on the day.",
    failedTitle: "Could not update the visits",
    failedBody: "Please try again.",
    count_one: "{{count}} visit",
    count_other: "{{count}} visits",
    status: {
      planned: "Planned",
      arrived: "Here since {{time}}",
      done: "Done",
      cancelled: "Cancelled",
    },
  },
  subJobs: {
    title: "Sub-jobs",
    progress: "{{done}} of {{total}} done",
    toCheck: "{{n}} to check",
    empty: "Split this job into smaller pieces of work, each with its own person and date. This job waits until they are all done.",
    add: "Add sub-job",
    inOrder: "Do them in order",
    partOf: "Part of {{title}}",
    partOfUnknown: "Part of a bigger job",
    unassigned: "Not assigned yet",
    waiting: "Waiting for the one before",
    waitsFor: "Waits for \"{{title}}\" to finish first.",
    cost: "Sub-jobs cost so far: {{amount}}",
    created: "Sub-job added",
    sheetTitle: "Add a sub-job",
    orderFailedTitle: "Could not change the order",
    orderFailedBody: "Check your connection and try again.",
    asOneJob: "Make them one job with sub-jobs",
    asOneJobHint: "One job holds all {{n}}, each with its own person and date. It closes when they are all done.",
    parentTitle: "Fix findings on {{asset}}",
    parentTitleNoAsset: "Fix inspection findings",
    parentBrief: "Holds {{n}} sub-jobs, one for each finding. It waits until they are all done.",
    openBlocksComplete_one: "1 sub-job is still open. Finish or cancel it before completing this job.",
    openBlocksComplete_other: "{{count}} sub-jobs are still open. Finish or cancel them before completing this job.",
    family: {
      status: {
        cancelled: "Cancelled",
        signed_off: "Signed off",
        needs_you: "Needs you",
        ready_to_sign_off: "Ready to sign off",
        in_progress: "In progress",
        scheduled: "Scheduled",
        waiting: "Waiting",
      },
      needs: {
        over_budget: "The sub-jobs' costs have gone past the job's budget.",
        declined: "A sub-job was declined. Give it to someone else to keep the job moving.",
        cant_complete: "Someone can't do their sub-job as scheduled. Decide it on the sub-job.",
        sent_back: "A sub-job was sent back and is being redone.",
        late: "A sub-job is late. Remind, reassign or move it.",
      },
      runBy: "Run by {{name}}",
      runByNobody: "Nobody runs this job yet",
      changeOwner: "Change who runs it",
      budget: "Budget {{budget}} · so far {{spent}}",
      overBudget: "Over budget by {{amount}}",
      forecast: "Finish forecast {{date}}",
      due: "Due {{date}}",
      checked: "Checked",
      needsCheck: "Done: check it",
      waitsForList: "Waits for {{titles}}",
      late: "Late",
      showAll: "Show all {{total}}",
      showFewer: "Show fewer",
      check: "Check the work",
      checkedToast: "Work checked",
      youAreHere: "You are here",
      stepOf: "Sub-job {{n}} of {{total}}",
      previous: "Previous",
      next: "Next",
      menu: {
        title: "{{title}}",
        open: "Open",
        start: "Start",
        schedule: "Schedule",
        reassign: "Reassign",
        remind: "Remind",
        pause: "Pause",
        skip: "Skip, with a reason",
        check: "Check the work",
        sendBack: "Send back",
        askPhotos: "Ask for photos",
        waitsFor: "What it waits for",
        separate: "Make it a separate job",
        moveTo: "Move to another job",
        run: "Run it",
        review: "Review",
        family: "Job",
      },
      reminded: "Reminder sent",
      remindedAlready: "Nothing to remind: it is finished or has nobody on it.",
      skipTitle: "Skip this sub-job?",
      skipMessage: "It counts as done for the job and is never shown as completed work.",
      skipPlaceholder: "Why is it not needed?",
      skipConfirm: "Skip it",
      skipped: "Sub-job skipped",
      sendBackTitle: "Send it back",
      sendBackMessage: "Say what needs redoing. {{name}} is told, and the work is checked again when it is finished.",
      sendBackPlaceholder: "What needs redoing?",
      sendBackConfirm: "Send back",
      sentBack: "Sent back",
      askPhotosTitle: "Ask for photos",
      askPhotosMessage: "Say what you need to see. It stays finished while {{name}} adds them.",
      askPhotosPlaceholder: "What do you need to see?",
      askPhotosConfirm: "Ask",
      asked: "Asked for photos",
      pausePlaceholder: "Why is it paused?",
      pauseTitle: "Pause this sub-job?",
      pauseConfirm: "Pause",
      paused: "Paused",
      separateTitle: "Make it a separate job?",
      separateMessage: "It leaves this job and keeps its person, dates and history. This job no longer waits for it.",
      separateConfirm: "Make it separate",
      separated: "It is a separate job now",
      signOff: "Sign off the whole job",
      signOffHint_one: "Signs off this job and its finished sub-job together.",
      signOffHint_other: "Signs off this job and its {{count}} finished sub-jobs together.",
      signOffFor: "Ready for {{name}} to sign off.",
      signedOff: "Job signed off",
      approvalEach: "I check each sub-job as it finishes",
      approvalEachHint: "The next one starts only after your check. Off: the approver checks everything once, at sign-off.",
      moveAll: "Move all dates",
      moveAllTitle: "Move the open sub-jobs",
      moveAllMessage: "By how many days? Put a minus sign to bring them forward.",
      moveAllConfirm: "Move",
      movedDates_one: "1 sub-job moved",
      movedDates_other: "{{count}} sub-jobs moved",
      moveDaysInvalid: "Enter a whole number of days, like 2 or -1.",
      cancelAll: "Cancel the whole job",
      cancelAllTitle: "Cancel the whole job?",
      cancelAllMessage: "The job and every sub-job not finished yet are cancelled, and their people are told. Finished work keeps its record.",
      cancelAllPlaceholder: "Why? (optional)",
      cancelAllConfirm: "Cancel the job",
      cancelledAll_one: "Job cancelled with 1 open sub-job",
      cancelledAll_other: "Job cancelled with {{count}} open sub-jobs",
      more: "More for this job",
      failedTitle: "Could not do that",
      failedBody: "Check your connection and try again.",
      waitsForTitle: "What does \"{{title}}\" wait for?",
      waitsForNone: "Nothing: it can start any time",
      waitsForSaved: "Saved",
      addExisting: "Add an existing job",
      addExistingTitle: "Add an existing job",
      addExistingEmpty: "No open job on this site can be added.",
      added: "Added to this job",
      moveToTitle: "Move to which job?",
      moveToEmpty: "No other open job on this site.",
      movedTo: "Moved",
      planTitle: "Plan the sub-jobs",
      planHint: "The work itself is done on the sub-jobs. This job closes when they are all done{{checked}}.",
      planHintChecked: " and checked",
      slipTitle_one: "Move the sub-job that waits for this one?",
      slipTitle_other: "Move the {{count}} sub-jobs that wait for this one?",
      slipMessage_one: "This one moved 1 day {{direction}}. Move them by the same, so the order still holds.",
      slipMessage_other: "This one moved {{count}} days {{direction}}. Move them by the same, so the order still holds.",
      later: "later",
      earlier: "earlier",
      budgetSet: "Set a budget",
      budgetMessage: "The sub-jobs' costs count against it; you are told when they go over. Enter 0 to remove it.",
      budgetConfirm: "Save",
      budgetInvalid: "Enter an amount, like 2500.",
      budgetSaved: "Budget saved",
      timeline: {
        today: "Today",
        forecast: "Forecast finish",
        undated_one: "1 sub-job has no date yet",
        undated_other: "{{count}} sub-jobs have no date yet",
      },
      activityFromSubJobs: "From the sub-jobs",
      activityLabel: "Sub-job {{n}}: {{title}}",
      addToThisJob: "Add to this job",
      separateJob: "Separate job",
      addedToThisJob: "Added to this job as the next sub-job",
      extraWaiting: "Extra work waiting for your decision: {{title}}",
      sentToRequester: "Sent to the requester to confirm. Sign off once they accept.",
      waitsForRequester: "The requester confirms the whole job first, then you sign it off.",
      template: {
        use: "Add sub-jobs from a template",
        save: "Save as a template",
        saveMessage: "Save these sub-jobs, their order and what waits for what. People, dates and costs are not kept.",
        saveConfirm: "Save template",
        saved: "Saved as \"{{name}}\"",
        pickTitle: "Templates",
        manage: "Manage",
        delete: "Delete \"{{name}}\"",
        deleted: "Template deleted",
        empty: "No templates yet. Save a job with sub-jobs as a template first.",
        row_one: "{{name}} · 1 step",
        row_other: "{{name}} · {{count}} steps",
        applied_one: "1 sub-job added",
        applied_other: "{{count}} sub-jobs added",
      },
      showMe: "Show me",
      mainContractor: {
        handOver: "Hand to a main contractor to run",
        takeBack: "Take the job back",
        takeBackTitle: "Take the job back?",
        takeBackMessage: "{{name}} stops running this job and you run it again. Sub-jobs already given out stay with whoever has them.",
        takenBack: "You run this job again",
        pickTitle: "Which contractor runs this job?",
        allowTitle: "May {{name}} use your contractors too?",
        allowYes: "Yes, they may give sub-jobs to our contractors",
        allowNo: "No, only their own people",
        handedOver: "{{name}} now runs this job",
        youRunIt: "You run this job for the client. Add sub-jobs for your crew; the client signs off at the end.",
        runsIt: "A main contractor runs this job. You sign off at the end.",
        nameCrew: "Name the crew",
        nameCrewMessage: "Who from your team does this sub-job? The client sees the name.",
        nameCrewConfirm: "Save",
        crewSaved: "Crew saved",
        crewPlaceholder: "For example: Lee",
        subJobTitle: "What needs doing",
        brief: "Brief (optional)",
        when: "When",
        who: "Who does it",
        ourCrew: "Our crew",
        crewName: "Crew or person",
        clientContractorHint: "The client's contractor gets the sub-job and its own reminders.",
        addAnother: "Add and next",
      },
      report: {
        summary: "Summary",
        full: "Full",
        internal: "Internal",
        forClient: "For the client",
        forClientHint: "For the client: no rates or contractor prices.",
        partOf: "Part of",
        checked: "Checked",
        checkedBy: "Checked by {{name}}",
        started: "Started {{date}}",
        finished: "Finished {{date}}",
        evidence_one: "1 photo or file",
        evidence_other: "{{count}} photos or files",
      },
      parts: {
        title: "Parts for the whole job",
        missing_one: "1 not in hand",
        missing_other: "{{count}} not in hand",
        allInHand: "All in hand",
        holdsUp: "Holds up {{title}}",
      },
      plan: {
        asset: "Asset",
        priority: "Priority",
        estimate: "Estimate",
        minutes: "How long (minutes)",
        waitsFor: "Waits for",
        copyFrom: "Copy from a past job",
        addAnother: "Add, then another",
        create: "Create sub-job",
        minutesOther: "Other length (minutes)",
        done: "Done",
        addedCount_one: "1 sub-job added",
        addedCount_other: "{{count}} sub-jobs added",
      },
      setup: {
        title: "Who runs this job?",
        hint: "The owner plans the sub-jobs, checks each one as it finishes and keeps the job moving.",
        me: "Me",
        current: "{{name}} (on it now)",
        someoneElse: "Someone else",
        keepOwnWork: "Keep the work already on this job as sub-job 1",
        keepOwnWorkHint: "{{name}} keeps that work and is asked to accept it again as a sub-job.",
        continue: "Continue",
      },
    },
  },
  detail: {
    handoffLock: {
      assignee: "Handed to {{name}}. What this job is stays as set; reassign it or take it back to change it.",
      quotes: "Out with contractors for quotes. What this job is stays as set; pick a quote or close the request to change it.",
      changeTheWork: "Change the work",
      changing: "You are changing this job. {{name}} has been told, and will be asked to accept it again when you are done.",
      doneChanging: "Done changing",
      beingChangedBy: "{{name}} is changing this job.",
      changedSinceAccepted: "This job changed since you accepted it. Review it, then accept it again.",
      revisedLength: "How long will it take now? (minutes)",
      opened: "Change opened. {{name}} has been told.",
      closed: "Change closed. {{name}} has been asked to accept the revised work.",
    },
    report: {
      sharePrepared: "{{title}} is ready.",
      shareSheetProviderHint: "Choose {{provider}} in the share sheet to save this file.",
      share: {
        word: "Share Word…",
        excel: "Share Excel…",
        pdf: "Share PDF…",
      },
      requestFailed: "That did not work. Check your connection and try again.",
      exportFailed: "The report file was not made. Check your connection and try again.",
      exportShared: "Report ready. It was handed to the share sheet to save or send.",
      exportDownloadStarted: "Your download has started. Find it in your downloads.",
      exportTitle: "Job completion report ({{format}})",
      brandingSettings: "Branding settings",
      openJob: "Open job",
      linkCopied: "Review link copied. Paste it into an email or message.",
      shareToGetLink: "Share the report to get a link",
      copyReviewLink: "Copy review link",
      reviewRequested: "review requested",
      sharedWith: "Shared with {{name}}",
      sharedReport: "Shared completion report",
      signedBy: "Signed by {{name}}",
      forYourRecords: "This report is for your records.",
      alreadyClosed: "This job is already closed.",
      sentBackMessage: "You sent the work back. The team will fix it and share the report again.",
      acceptedThanks: "You accepted the work. Thank you.",
      acceptedTeamCloses: "You accepted the work. The team will now close the job.",
      sendBack: "Send back",
      acceptWork: "Sign off",
      signOffPrompt: "Look over the work above. If you’re happy, sign to sign off. If not, tap Send back and say what needs fixing.",
      decisionFailedBody: "Check your connection and try again.",
      decisionFailedTitle: "Your answer was not sent",
      sentBackToast: "Sent back. The team has been told what needs fixing.",
      acceptedToast: "Thanks. The team has been told you’re happy with the work.",
    },
    contextCard: {
      untitledJob: "Untitled job",
      created: "Created",
      createdBy: "Created by {{name}}",
      showFewerDetails: "Show fewer details",
      showMoreDetails: "Show more details",
      fewerDetails: "Fewer details",
      moreDetails: "More details",
      dueAndScheduled: "Due {{due}} · scheduled {{scheduled}}",
      scheduled: "Scheduled {{scheduled}}",
      due: "Due {{due}}",
      contacts: "Contacts",
      when: "When",
      why: "Why",
      what: "What",
      where: "Where",
      asset: "Asset",
    },
    actionSheets: {
      failedToAskForPhotos: "Your request for photos was not sent. Check your connection and try again.",
      failedToSendBack: "The job was not sent back. Check your connection and try again.",
      failedToDecline: "The job was not declined. Check your connection and try again.",
      failedToCancel: "The job was not cancelled. Check your connection and try again.",
      failedToPause: "The job was not paused. Check your connection and try again.",
      askedForPhotosUnnamed: "Asked for more photos. The job waits for your review.",
      askedForPhotos: "Asked {{assignee}} for more photos. The job waits for your review.",
      sentBackUnnamed: "Sent back with your note. You’ll be told when it is resubmitted.",
      sentBack: "Sent back to {{assignee}} with your note. You’ll be told when they resubmit.",
      declined: "Job declined. The person who assigned it has been told and can reassign it.",
      cancelled: "Job cancelled. It stays in the job history.",
      paused: "Job paused. Tap Resume when the work can carry on.",
    },
    fieldAssist: {
      failedTitle: "Couldn’t tidy this up",
      revert: "Revert",
      discard: "Discard",
      accept: "Accept",
      rationale: "Check the wording, then tap Accept. Your text stays until you do.",
      draftTitle: "Tidied-up text",
      tidying: "Tidying up…",
      tidyUp: "Tidy up with AI",
      stop: "Stop",
      dictate: "Dictate",
    },
    deliveryMode: {
      hint: {
        PRIVATE_QUOTES: "Ask a few contractors for a price, then pick one.",
        DIRECT_CONTRACTOR: "Send it to one contractor you already use.",
        INTERNAL: "Someone on your team does the work.",
      },
      label: {
        PRIVATE_QUOTES: "Get quotes",
        DIRECT_CONTRACTOR: "A contractor",
        INTERNAL: "Our team",
      },
      title: "Who does it?",
    },
    title: 'Job',
    actionModals: {
      send: "Send",
      pauseReasons: {
        waitingOnParts: 'Waiting on parts',
        weatherDelay: 'Weather delay',
        customerRequest: 'Customer request',
        other: 'Other',
      },
      declineReasons: {
        scheduleConflict: 'Schedule conflict',
        noCapacity: "Too busy right now",
        wrongTrade: "Needs a different skill",
        needMoreInfo: 'Need more information',
      },
      pauseTitle: 'Pause job',
      pauseReasonRequiredHint: 'Reason is required so the team knows why work is on hold.',
      additionalDetailOptional: 'Additional detail (optional)',
      additionalDetailPlaceholder: 'e.g. Expected back in stock next week',
      cancel: 'Cancel',
      pause: 'Pause',
      cancelJobTitle: 'Cancel job',
      cancelJobConfirm: 'Are you sure? This cannot be undone.',
      reasonOptional: 'Reason (optional)',
      cancellationReasonPlaceholder: 'e.g. No longer needed',
      back: 'Back',
      yesCancel: 'Yes, cancel',
      declineJobTitle: "Decline job",
      declineReasonRequiredHint: 'A reason is required. The person who assigned this job will be notified.',
      reasonRequired: 'Reason (required)',
      declineReasonPlaceholder: 'e.g. Schedule conflict, capacity, other commitment',
      additionalNoteOptional: 'Additional note (optional)',
      additionalNotePlaceholder: 'Any details for the assigner',
      declineJob: "Decline",
      reworkTitle: "Send back",
      reworkHint: "Say what needs fixing. The person who did the work sees your note and sends it back for review once it’s fixed.",
      reworkReasonPlaceholder: 'e.g. Photos missing for X, actual cost not filled, notes unclear',
      evidenceTitle: "Ask for photos",
      evidenceHint: "Say what you need to see. The job stays with you for review while they add the photos.",
      evidenceReasonPlaceholder: "e.g. A clear photo of the lower mounting area",
      requestEvidence: "Ask for photos",
      rework: "Send back",
    },
    detailScreen: {
      followUpNeeded: "Follow-up needed: {{reason}}.",
      receiptsAndInvoices: "Receipts and invoices",
      verifyInTheirPlace: "Verify in their place",
      completedSolo: "Done. The job is closed.",
      assignedInviteFailedBody: "The job is theirs, but the invite email could not be sent. Let them know yourself.",
      assignedInviteFailedTitle: "Assigned, but the email did not go",
      noTeamBody: "We could not tell which team this job belongs to, so the contractor was not invited. Check your connection and try again.",
      noTeamTitle: "No team for this job",
      failedToResume: "The job was not resumed. Check your connection and try again.",
      failedToAssign: "The job was not assigned. Check your connection and try again.",
      addTitleFirst: 'Add a title first',
      addDescriptionFirst: 'Add a description first',
      typeOrDictateTitleHint: 'Type or dictate a short title, then use Improve with AI.',
      typeOrDictateDescriptionHint: 'Type or dictate a description, then use Improve with AI.',
      unableToImproveText: 'Unable to improve text',
      tryAgain: 'Please try again.',
      verifiedInPlaceOf: 'Verified in place of {{name}}',
      couldNotVerify: 'Could not verify',
      tryAgainShort: 'Try again.',
      stageAdded: '{{stage}} added',
      couldNotAddCheck: 'Couldn’t add that check',
      precheckFirst: 'Precheck first',
      notNow: 'Not now',
      runStage: 'Run {{stage}}',
      couldNotStartJob: 'Could not start this job',
      movedToStatus: 'Moved to {{status}}',
      couldNotMoveJob: 'Could not move this job',
      acceptedOn: 'Accepted on',
      rejectedOn: 'Rejected on',
      sentToLine: 'Sent to {{names}}.',
      missingEmailForLine: 'Missing email for {{names}}.',
      noInvoiceOrReceiptAttached: 'No invoice or receipt files were attached.',
      completionSentTitle: 'Completion sent',
      completionEmailSent: 'Completion email sent.',
      emailNotSentTitle: 'Email not sent',
      visitConfirmed: 'Visit confirmed',
      awaitingVisitConfirmation: 'Awaiting visit confirmation',
      recipientLine: '{{label}}: {{name}}',
      recipientEmailSuffix: ' ({{email}})',
      requesterDeliveryLine: 'Requester: {{status}}',
      assigneeDeliveryLine: 'Assignee: {{status}}',
      helpMeWithJobDraft: 'Help me with this job: {{title}}. Suggest next steps or a close-out draft.',
      currentJobFallback: 'Current job',
      captureNotSavedTitle: 'Capture not saved',
      captureNotFoundBody: 'That capture could not be found. Please capture it again.',
      captureMismatchBody: 'This capture does not match the current job.',
      noPhotoWasCaptured: 'No photo was captured.',
      mustBeSignedInToSavePhotos: 'You must be signed in to save photos.',
      capturedFromHome: 'Captured from Home',
      photoAddedToActivity: 'Photo added to job activity',
      noDictationTextCaptured: 'No dictation text was captured.',
      jobUpdateAdded: "Update posted. Everyone on this job can see it under Activity.",
      noNoteTextCaptured: 'No note text was captured.',
      activityNoteAdded: "Note added. Everyone on this job can see it under Activity.",
      readingCostNotePrefix: 'Reading/cost note: {{value}}',
      readingAddedToActivity: 'Reading added to job activity',
      captureNotSupportedTitle: 'Capture not supported',
      qrScanNotSavedBody: 'QR scan is handled from the scanner, not saved to job activity.',
      captureModeNotSupported: 'This capture mode is not supported for jobs.',
      skillsUnavailableTitle: 'Skills unavailable',
      skillsUnavailableBody: 'Could not load skills right now. You can retry in the picker.',
      followOnTitleSuffix: "{{title}} (follow-up)",
      workFallback: 'Work',
      revisedWorkSubmitted: "Revised work sent for review. The reviewer has been told.",
      completionSubmittedAwaitingVerification: "Sent for review. The reviewer checks it, then verifies it or sends it back.",
      unableToCleanUp: 'Unable to clean up',
      changeApproved: "Change approved. The job now shows the new date or person, and the person who asked has been told.",
      requestRejected: "Request turned down. The job stays as it was, and the person who asked has been told.",
      error: "Something went wrong",
      couldNotRecordDecision: "Your decision was not saved. Check your connection and try again.",
      savedOnDeviceWillSend: 'Saved on this device — it will send when you are back online',
      requestSent: "Request sent. Nothing changes until the person in charge approves it; you will be told.",
      couldNotSendRequest: "Your request was not sent. Check your connection and try again.",
      outcomeLinePrefix: 'Outcome: {{value}}',
      meterReadingTitle: 'Meter reading',
      enterMeterReadingBody: 'Enter the meter reading as a number, or leave it blank.',
      readingLowerThanCurrentBody: '{{amount}} is lower than the current {{current}}. Check the number — or record a correction from the asset’s Maintenance card.',
      readingLowerThanEarlierBody: 'This reading is lower than an earlier one. Check the number.',
      readingAlreadyRecordedAfterBody: 'A reading of {{current}} is already recorded after this one. Check the number.',
      laterReadingAlreadyRecordedBody: 'A later reading is already recorded. Check the number.',
      meterReadsInUnitBody: 'This meter reads in {{unit}}.',
      completionSubmittedAwaitingOwnerVerification: "Sent for review. The person who set the job checks it, then verifies it or sends it back.",
      failedToComplete: "The job was not submitted. Your notes and photos are kept. Check your connection and try again.",
      completeRequiredDetailsFirstTitle: 'Complete required details first',
      pleaseFixBeforeSubmitting: 'Please fix these before submitting completion:\n{{list}}',
      goToCompletion: 'Go to Completion',
      cancel: 'Cancel',
      costBreakdownActionUnavailable: 'Cost breakdown action unavailable. Please refresh the app.',
      jobAccepted: "Job accepted. Tap Start when you begin the work.",
      failedToAccept: "The job was not accepted. Check your connection and try again.",
      workApproved: "Work verified. The job is closed and the asset history is updated.",
      requireSignOffForJobsThisSize: 'Require sign-off for jobs this size',
      failedToApprove: "The work was not verified. Check your connection and try again.",
      cannotCreateCertificateTitle: 'Cannot create certificate',
      cannotCreateCertificateBody: 'This job is not linked to an asset.',
      certificateCreatedTitle: 'Certificate created',
      certificateCreatedBody: 'The certificate is linked to this job and asset.',
      couldNotCreateCertificate: 'Could not create certificate.',
      deleteJobTitle: 'Delete job',
      actionCannotBeUndone: 'This action cannot be undone.',
      delete: 'Delete',
      jobDeleted: 'Job deleted',
      failedToDelete: "The job was not deleted. Check your connection and try again.",
      titleRequiredTitle: 'Title required',
      enterFollowOnTitleBody: "Enter a title for the follow-up job.",
      skillsRequiredTitle: 'Skills required',
      selectRequiredSkillBody: "Choose at least one skill for this follow-up job.",
      followUpJobCreated: "Follow-up job created. It is in Work and linked to this job.",
      followUpCreatedTitle: 'Follow-up created',
      followUpCreatedBody: 'Linked follow-up job created. You can open it from Completion or continue completing this job.',
      failedToCreateFollowOn: "The follow-up job was not created. Check your connection and try again.",
      failedToApproveFollowOn: "The follow-up was not approved. Check your connection and try again.",
      notApproved: 'Not approved',
      followUpNotApproved: "Follow-up turned down. It is cancelled, and your reason is in its history.",
      failedToRejectFollowOn: "The follow-up was not turned down. Check your connection and try again.",
      linkAContact: 'Link a contact',
      requesterFallback: 'Requester',
      draftCloseout: "Draft the note with AI",
      draftInvoice: 'Draft invoice',
      loadingJobDetails: 'Loading job details...',
      unableToLoadJob: 'Unable to load job',
      jobNotFound: 'Job not found',
      ownerFallback: 'Owner',
      parentJobApproverFallback: 'Parent-job approver',
      assigneeFallback: 'Assignee',
      everyoneDeclinedYouInviteMore: 'Everyone invited declined — you invite more',
      everyoneDeclined: 'Everyone invited declined',
      contractorsSubmitQuotes: 'Contractors submit quotes',
      youRequestQuotes: 'You request quotes',
      ownerRequestsQuotes: 'Owner requests quotes',
      youPickAContractor: 'You pick a contractor',
      ownerPicksAContractor: 'Owner picks a contractor',
      youAssignTheJob: 'You assign the job',
      ownerAssignsTheJob: 'Owner assigns the job',
      requesterConfirmsFixNamed: '{{name}} confirms the fix',
      assignedPrefix: 'Assigned',
      assignedToSuffix: ' to {{name}}',
      resolveBeforeSubmitting: 'Resolve this before submitting completion.',
      tightenEvidenceCostsNotes: 'Tighten evidence, costs, or notes so approval is straightforward.',
      captureFollowUpWorkHint: 'Capture follow-up work or a linked job so nothing slips.',
      noScheduledStartExplanation: 'This job has no scheduled start.',
      setScheduleRecommendedAction: "No date yet. Pick a date or assign it so it doesn’t slip.",
      pastScheduledStartExplanation: 'This job is past its scheduled start or due date.',
      updateScheduleRecommendedAction: "It’s past its date. Reschedule it or tell the requester.",
      completionChecksClear: 'Completion checks look clear for the current record.',
      keepUpdatesAlignedAction: 'Keep updates, evidence, costs, and notes aligned as work progresses.',
      reviewCompletion: 'Review completion',
      openCompletion: 'Open completion',
      setSchedule: 'Set schedule',
      updateSchedule: 'Update schedule',
      inspectionLine: 'Inspection: {{label}}',
      openRelatedAsset: 'Open related asset',
      jobInsight: 'Job insight',
      insightWarnings_one: "{{count}} warning",
      insightWarnings_other: "{{count}} warnings",
      insightBlockers_one: "{{count}} blocker",
      insightBlockers_other: "{{count}} blockers",
      insightSummaryLine: "{{warnings}}, {{blockers}}",
      followUp: 'Follow-up',
      suggested: 'Suggested',
      thisJobsChecksAndStatus: 'this job’s checks and status',
      contractorWorkspace: 'Contractor Workspace',
      nextLine: 'Next: {{value}}',
      statusUnavailable: 'Status unavailable',
      updatesNew: 'Updates · new',
      updates: 'Updates',
      hideStatusHistory: 'Hide status history',
      statusHistory: 'Status history',
      hideCompletionAndCosts: 'Hide completion & costs',
      completionAndCosts: 'Completion & costs',
      cancelJob: 'Cancel job',
      deleteJobAction: 'Delete job',
      moreJobOptions: 'More job options',
      approveCompletion: "Verify",
      cantDoThis: "Decline",
      assignDirectly: 'Assign directly',
      jobAssistant: 'Job assistant',
      readOnly: 'Read-only',
      jobCreated: 'Job created',
      suggestedNextStepLine: 'Suggested next step: {{step}}.',
      trackProgressHint: 'Track progress in Activity, then close out when the work is complete.',
      dismissJobCreatedMessage: 'Dismiss job created message',
      gotIt: 'Got it',
      atAGlance: 'At a glance',
      status: 'Status',
      next: 'Next',
      visit: 'Visit',
      cost: 'Cost',
      openAssetLabel: 'Open asset {{name}}',
      relatedRecords: 'Related records',
      couldNotSaveJobDetails: 'Could not save job details.',
      jobOptions: 'Job options',
      linkContactToJob: 'Link contact to job',
      relationship: 'Relationship',
      couldNotAddExtractedLineItem: 'Could not add extracted line item',
      jobFallback: 'Job',
      signInRequiredToUpload: 'Sign in required to upload.',
      reopenJob: 'Reopen job',
      startJob: 'Start job',
      acceptJob: 'Accept job',
      workPath: "Who does it",
      overdue: 'Overdue',
      unscheduled: 'Unscheduled',
      onSiteLine: 'On site: {{location}}',
      fromInspectionLine: 'From inspection — {{label}}',
      followOnOfLine: "Follow-up of — {{title}}",
      parentJobFallback: 'parent job',
      requestedByLine: 'Requested by — {{name}}',
      roleAndNameLine: '{{role}} — {{name}}',
      jobAssigned: "Job assigned. They have been told and need to accept it.",
      contractorAssigned: "Contractor assigned. They have been sent an invite and need to accept the job.",
      jobResumed: "Job resumed. Tap Complete when the work is done.",
    },
    closeout: {
      extractLineItems: "Read items from the invoice",
      extractingLineItems: "Reading the invoice…",
      generatingInvoice: "Making the invoice…",
      materialsSummary: "Add parts and materials. We’ll total them for the invoice.",
      followUpTitle: 'Follow-up',
      suggestFollowUpWork: 'Suggest follow-up work',
      suggestNextSteps: 'Suggest next steps',
      apply: 'Apply',
      skillLine: 'Skill: {{value}}',
      riskLine: 'Risk: {{value}}',
      costsAndInvoicesIncluded: '. Costs and invoices are included below.',
      completedThisLine: '{{name}} completed this{{when}}. ',
      requesterConfirmsFix: 'Requester confirms the fix',
      ownerFallback: 'Owner',
      addDetailsBeforeSubmitting: 'Add completion details before submitting.',
      submitCompletion: 'Submit completion',
      completion: 'Completion',
      followUpJobsTitle: 'Follow-up jobs',
      followUpJobsSummary: "Add or check follow-up jobs once this job’s completion note is ready.",
      proposeFollowOnJob: "Propose a follow-up job",
      linkedHeldForApproval: 'Linked to this job and held for approval.',
      proposeMoreWork: "Propose more work",
      proposeMoreWorkHint: "It goes to them as a request. They decide, and you see the answer here.",
      proposalSent: "Proposal sent",
      proposalWaiting: "Waiting for a decision",
      proposalApproved: "Approved",
      proposalBecameJob: "Became a job",
      proposalNotTaken: "Not taken forward",
      followUpJobsLinkedTitle: 'Follow-up jobs linked',
      createdNowPrefix: 'Created now: ',
      followUpPrefix: 'Follow-up: ',
      pendingApprovalSuffix: ' · Pending approval',
      followUpLinkedContinueBody: "The follow-up job is linked. You can carry on and complete this job.",
      requiredBeforeSubmit: 'Required before submit',
      beforeYouSubmit: 'Before you submit',
      workCompleted: 'Work completed',
      workCompletedPlaceholder: 'What work was completed?',
      rewriting: "Tidying up…",
      rewrite: "Tidy up with AI",
      revert: 'Revert',
      actualCost: 'Actual cost',
      leaveBlankToRecordAsZero: 'Leave blank to record as 0. Enter the full amount for this job if there was a charge.',
      fromCostBreakdownReadOnly: 'From cost breakdown (read-only)',
      verifiedLine: 'Verified {{date}} | Actual cost {{amount}}',
      costsLockedPendingVerification: 'Costs are locked while completion is pending verification.',
      quickFinishHint: 'Quick finish: add completion details and actual cost, then submit.',
      costSummary: 'Cost summary',
      estimateLine: 'Estimate: {{value}}',
      actualTotalLine: 'Actual total: {{value}}',
      vsEstimateLine: 'vs estimate: {{value}}',
      actualCostHint: 'Actual cost should include all charges for this job.',
      optionalBreakdownHint: 'Optional: add a detailed breakdown only if needed.',
      detailedCostBreakdown: 'Detailed cost breakdown',
      detailedCostBreakdownSummary: 'Materials, labour, tax, and other charges are optional unless this job needs itemised costs.',
      optionalDetailedCostBreakdown: 'Optional detailed cost breakdown',
      materialsBreakdownOptional: 'Materials breakdown (optional)',
      lineItemsOptional: 'Line items (optional)',
      failedToAddLineItem: "The item was not added. Check your connection and try again.",
      add: 'Add',
      itemName: 'Item name',
      removeItemTitle: 'Remove item',
      removeItemBody: 'Remove this line item?',
      cancel: 'Cancel',
      remove: 'Remove',
      error: "Something went wrong",
      failedToUpdateLineItem: "The item was not saved. Check your connection and try again.",
      failedToRemoveLineItem: "The item was not removed. Check your connection and try again.",
      failedToUpdateQty: "The quantity was not saved. Check your connection and try again.",
      failedToUpdateUnitCost: "The unit price was not saved. Check your connection and try again.",
      failedToUpdateTotalCost: "The total was not saved. Check your connection and try again.",
      quantityForItem: 'Quantity for {{name}}',
      itemFallback: 'item',
      qty: 'Qty',
      unitCostForItem: 'Unit cost for {{name}}',
      unit: 'Unit',
      totalForItem: 'Total for {{name}}',
      total: 'Total',
      fromQtyTimesUnit: 'From qty × unit: {{amount}}',
      manualTotalOverrideSuffix: " (you changed the total)",
      useCalculatedTotal: 'Use calculated total',
      materialsSubtotal: 'Materials subtotal: {{amount}}',
      labourTaxOtherOptional: 'Labour, tax, and other charges (optional)',
      costBreakdownOptional: 'Cost breakdown (optional)',
      failedToRemoveBreakdown: "The breakdown was not removed. Check your connection and try again.",
      failedToAddCostBreakdown: "The breakdown was not added. Check your connection and try again.",
      removeBreakdown: 'Remove breakdown',
      addBreakdown: 'Add breakdown',
      labourExTax: 'Labour (ex. tax)',
      taxEntry: 'Tax entry',
      amount: 'Amount',
      percentOfLabour: '% of labour',
      taxAmount: 'Tax amount',
      taxRatePercentOfLabour: 'Tax rate (% of labour)',
      taxRateLine: 'Tax rate: {{pct}}%',
      otherCharges: 'Other charges',
      otherChargeLabel: 'Other charge {{n}} label',
      label: 'Label',
      otherChargeAmount: 'Other charge {{n}} amount',
      totalBreakdownLine: 'Total = Materials {{materials}} + Labour {{labour}} + Tax {{tax}} + Other {{other}}',
      totalLine: 'Total: {{amount}}',
      invoicesAndCloseoutEmail: "Invoices and report email",
      invoicesAndCloseoutEmailSummary: "Attach invoices, or email the report once the completion note is ready.",
      invoiceLabel: 'Invoice (PDF, image, or Word)',
      generateInvoiceWithAi: 'Generate invoice with AI',
      reviewInvoiceDraft: 'Review invoice draft',
      signInRequired: 'Sign in required',
      emailCloseoutRecipients: "Email the report to the requester",
      emailAlwaysIncludesSummary: "The email includes a summary of the work. Invoices, receipts and photos are attached when there are any.",
    },
    assetContextSection: {
      asset: 'Asset',
      viewAssetKnowledgeBase: 'View asset knowledge base',
      viewAssetKnowledge: 'View asset knowledge',
      noAssetLinked: 'No asset linked to this job.',
      overview: 'Overview',
      location: 'Location',
      fromLinkedAsset: 'From linked asset',
      aboutThisJob: 'About this job',
      approverLine: 'Approver: {{name}}',
      approverFallback: '-',
      sectionOfInterest: 'Section of interest',
      viewSourceInspection: 'View source inspection',
      fromInspection: 'From inspection',
      video: 'Video',
      photos: 'Photos',
      linkedRecords: 'Linked records',
      fromRequestLine: 'From request: {{id}}',
      followsFromLine: 'Follows from: {{title}}',
      parentJobFallback: 'Parent job',
      followOnLine: "Follow-up: {{title}}",
      sourceLine: 'Source: {{label}}',
      groupedScheduleLine_one: '{{count}} other active job on this asset can be scheduled together.',
      groupedScheduleLine_other: '{{count}} other active jobs on this asset can be scheduled together.',
    },
    scheduleSection: {
      rescheduleTo: 'Reschedule to',
      scheduleFor: 'Schedule for',
      today: 'Today',
      tomorrow: 'Tomorrow',
      nextWeek: 'Next week',
      custom: 'Custom',
      selectDate: 'Select date',
      time: 'Time',
      selectTime: 'Select time',
      duration: 'Duration',
      plannedLine: 'Planned: {{value}}',
      reasonOptional: 'Reason (optional)',
      reasonForReschedulePlaceholder: 'Reason for reschedule',
      scheduleTogetherOptional: 'Schedule together (optional)',
      groupSameAssetHint: 'Group same-asset work to reduce repeat visits.',
      unscheduledSuffix: ' | Unscheduled',
      cancel: 'Cancel',
      reschedule: 'Reschedule',
      schedule: 'Schedule',
    },
    deliveryModeSheet: {
      cancel: 'Cancel',
      saving: 'Saving...',
      save: 'Save',
    },
    mediaViewer: {
      couldNotLoadImage: 'Could not load image',
      imageUnavailable: 'The image may have been moved or is unavailable.',
    },
    handoffRecommendationPanel: {
      evidence: {
        beforeAfter: "When done: before and after photos and a short note.",
        replacementPhotos: "When done: before and after photos and what was fitted.",
        checklistPhotos: "When done: the finished checklist and photos of anything that failed.",
      },
      reason: {
        originKept: {
          finding: "It stays linked to the inspection finding.",
          inspection: "It stays linked to the inspection.",
          request: "It stays linked to the request.",
          asset: "It stays linked to the asset.",
        },
        noOrigin: "Check the details above before you create it.",
        skillsUnconfirmed: "No skills added yet. Add them if a specific trade is needed.",
        skillsCarried_other: "{{count}} skills are already on the job.",
        skillsCarried_one: "{{count}} skill is already on the job.",
        dueByPriority_other: "{{priority}} priority: aim to finish within {{count}} days.",
        dueByPriority_one: "{{priority}} priority: aim to finish within {{count}} day.",
        contractorNoInternal: "Nobody on your team is free: choose a contractor.",
        contractorFromSourceJob: "It goes back to the contractor who did the job it came from.",
        contractorCritical: "Nobody on your team is free, and it is urgent: send it straight to a contractor you trust.",
        quotesHighValue: "Nobody on your team is free, and this is costly work: compare a few quotes first.",
        internalAvailableUnnamed: "Someone on your team can do it.",
        internalAvailable: "{{name}} on your team can do it.",
      },
      recommendedHandoff: 'Suggested',
      titleLine: '{{mode}} · due in {{days}} {{dayWord}}',
      dayWord_one: 'day',
      dayWord_other: 'days',
      applied: 'Applied',
      apply: "Use this suggestion",
      whyRecommendedTitle: 'Why?',
      priorityOverrideLine: "Priority: {{priority}}. Change it under Add context if that is wrong.",
      planningRangeLine: 'Planning range {{min}}–{{max}}; confirm before commissioning.',
    },
    statusInsight: {
      theReviewer: "The reviewer",
      reworkRequested: "Sent back",
      workPath: "Who does it",
      updating: 'Updating...',
      internal: 'Internal',
      recipientView: 'Recipient view',
      recipientViewBody: 'You can review this job. Editing is limited to what your role allows.',
      execution: "Doing the work",
      executionBody: "When the work is done, tap Complete to add your note, photos and costs.",
      nextStep: 'Next step',
      nextLine: 'Next: {{actor}}',
      followOnApproval: "Follow-up approval",
      followOnApprovalBody: "Approve this follow-up job so it can be assigned and given a date.",
      awaitingFollowOnApproval: "Waiting for approval",
      waitingForApproverBody: "This follow-up job is waiting for approval. It can’t be assigned or given a date until it is approved.",
      waitingForParentApproverBody: 'This job cannot be assigned or scheduled until the parent-job approver decides.',
      overdue: 'Overdue',
      unscheduled: 'Unscheduled',
    },
    activitySection: {
      assistantChange: "Changed via the assistant",
      assistantUndone: "Assistant change undone",
      playVideo: "Play video",
      openPhoto: "Open photo",
      statusNone: 'None',
      systemActor: 'System',
      userFallback: "Someone on the team",
      taskTimeline: 'Task timeline',
      purposeHint: 'Status, messages, evidence and actions in one chronological workspace.',
      noStatusEvents: 'No status events yet.',
      recentEvidence: 'Recent evidence',
      noMessagesOrEvidence: 'No messages or evidence yet.',
      openFullTimeline: 'Open full timeline >',
    },
    assignmentSection: {
      contacts: 'Contacts',
      noContactsLinked: 'No contacts linked.',
      contactFallback: 'Contact',
      couldNotUnlinkTitle: 'Could not unlink contact',
      tryAgain: 'Please try again.',
      linkContact: 'Link contact',
      assignmentAndSchedule: 'Assignment & schedule',
      declinedSuffix: '{{name}} (declined)',
      awaitingAssignee: 'Awaiting assignee',
      requesterLine: 'Requester: {{name}}',
      requesterEmailSuffix: ' ({{email}})',
      notLinkedYet: 'Not linked yet',
      scheduledLine: 'Scheduled: {{value}}',
      notScheduledYet: 'Not scheduled yet',
      closeoutRecipientsFallback: "Once someone is assigned, we’ll show who gets the finished report.",
      completionEmailLine: 'Completion email: {{value}}',
      rejected: 'Rejected',
      changeAssignee: 'Change assignee',
      change: 'Change',
      reassign: 'Reassign',
      contractorType: 'Contractor',
      internalTeamType: 'Internal team',
      reason: 'Reason',
      invitedAcceptedDeclinedLine: 'Invited: {{total}} | Accepted: {{accepted}} | Declined: {{declined}}',
      pendingSuffix: ' | Pending: {{pending}}',
      quoteRequestLine: 'Quote request: {{status}}',
      quoteInvitedSubmittedDeclinedLine: '{{invited}} invited | {{submitted}} submitted | {{declined}} declined',
      quoteCountLine_one: "{{count}} quote: {{open}} open | {{accepted}} accepted | {{rejected}} rejected",
      quoteCountLine_other: "{{count}} quotes: {{open}} open | {{accepted}} accepted | {{rejected}} rejected",
      awardedToLine: 'Awarded to: {{name}}',
      execution: "The work",
      started: 'Started',
      completed: 'Completed',
      actualDuration: 'Actual duration',
      elapsed: 'Elapsed',
      confirmed: 'Confirmed',
      confirmedBySuffix: ' · {{name}}',
      verified: 'Verified',
      continueJob: 'Continue the job',
      continueJobHint: 'Add completion details and actual cost before submitting.',
      completion: 'Completion',
    },
    statusGuidance: {
      title: 'Status & guidance',
    },
    invoicePreview: {
      title: 'Review AI invoice draft',
      hint: 'Confirm the details, then attach the generated PDF to this job.',
      titleAndNumber: '{{title}} - {{number}}',
      issueDate: 'Issue date: {{date}}',
      dueDateSuffix: ' | Due: {{date}}',
      from: 'From',
      billTo: 'Bill to',
      lineItems: 'Line items',
      lineItemLine: '{{description}} x{{quantity}} - {{amount}}',
      total: 'Total: {{amount}}',
      noDraftFound: 'No draft found. Generate an invoice draft first.',
      back: 'Back',
      attaching: 'Attaching…',
      attachPdf: 'Attach PDF',
    },
    followOnModals: {
      proposeTitle: "Propose a follow-up job",
      proposeHint: "It waits for approval. Once approved, it can be assigned and given a date.",
      titleLabel: 'Title',
      descriptionLabel: 'Description',
      dictate: 'Dictate',
      improving: 'Improving…',
      improveWithAi: 'Improve with AI',
      followOnTitleAria: "Follow-up job title",
      titlePlaceholder: 'Title',
      followOnDescriptionAria: "Follow-up job description",
      descriptionPlaceholder: 'What extra work is needed?',
      insertingDictatedText: 'Inserting dictated text...',
      finishingDictation: 'Finishing dictation...',
      heardTranscript: 'Heard: {{transcript}}',
      listening: 'Listening...',
      photosAndVideos: 'Photos & videos',
      requiredSkills: 'Required skills',
      cancel: 'Cancel',
      submitting: 'Submitting…',
      submitForApproval: 'Submit for approval',
      rejectTitle: "Decline follow-up job",
      rejectHint: "The follow-up job is cancelled. Add a short reason for the team.",
      rejectionReasonAria: "Reason for declining",
      reasonPlaceholder: 'Reason',
      rejectFollowOn: "Decline",
    },
    dockBar: {
      waitingForRequester: "Waiting for the requester",
      approve: 'Approve',
      reject: "Decline",
      accept: 'Accept',
      acceptAndStart: "Accept and start",
      acceptAndSchedule: "Accept and schedule",
      cantDoThis: "Decline",
      reassign: 'Reassign',
      rework: "Send back",
      requestEvidence: "Ask for photos",
      verify: 'Sign off',
      resubmit: 'Resubmit',
      getQuotes: 'Get quotes',
      inviteMore: 'Invite more',
      compare: 'Compare',
      sendQuotes: 'Send quotes',
      assign: 'Assign',
      startNow: 'Start now',
      schedule: 'Schedule',
      start: "Start",
      reschedule: 'Reschedule',
      complete: 'Complete',
      pause: 'Pause',
      resume: 'Resume',
      report: 'Report',
    },
    certificateSuggestion: {
      needsConnection: 'Certificate suggestions need a connection.',
      evidenceDoesNotSupport: 'Completion evidence does not clearly support a certificate yet.',
      createPendingTitle: 'Create pending certificate',
      createPendingBody: 'Create a certificate from this job? It will stay pending validation until reviewed.',
      cancel: 'Cancel',
      continue: 'Continue',
      jobFallback: 'Job',
      certificateSuffix: '{{title}} certificate',
      titleLine: 'Title: {{value}}',
      typeLine: 'Type: {{value}}',
      expiryLine: 'Expiry: {{value}}',
      cardTitle: 'Suggest certificate from completion evidence',
      optionalAiHint: 'Optional AI assist after job completion.',
      reviewDraftLabel: 'Review certificate draft',
      suggestWithAi: 'Suggest certificate with AI',
      addManually: 'Add certificate manually',
    },
    verified: {
      submitCheckNote: "When you submit, AI checks the after photos against what this job needs.",
      documentHintSheet: "Close this, then tap Attach document on the job.",
      noteHintSheet: "Write it in the completion note on this screen.",
      noteHint: "Write it in the completion note when you tap Complete.",
      attachDocument: "Attach document",
      recordReading: "Record reading",
      heading: "What this job needs",
      progress: "{{done}} of {{total}} done",
      takePhoto: "Take photo",
      stage: {
        pre: "Before you start",
        post: "When you finish",
        standalone: "Checklist",
      },
      beforePhoto: "Before photo",
      afterPhoto: "After photo",
      beforePhotos: "Before photos",
      addBeforePhoto: "Add before photo",
      required: "Required",
      recommended: "Recommended",
      rowState: {
        notSupplied: "Not supplied",
        done: "Done",
        uploading: "Uploading…",
        added: "Added",
        missing: "Missing",
        attention: "Needs a look",
        unchecked: "Not checked yet",
      },
      status: {
        consistent: "Photos match the work described",
        review_required: "Photos need a look",
        missing_evidence: "Photos missing",
        inconsistent: "Photos do not match the work described",
        unable_to_determine: "Could not tell from the photos",
      },
      checkNote: {
        meter_not_recorded: "Meter reading not recorded",
        document_not_attached: "Document not attached",
        check_not_completed: "Check not completed",
        note_missing: "Note missing",
        not_visible: "Not visible in the photos",
        partly_visible: "Only partly visible",
        low_confidence: "Not clear enough to be sure",
        contradicted: "The photos show the opposite",
        cloud_unavailable: "Automated evidence assessment unavailable",
        not_visually_verifiable: "Cannot be determined from photos",
      },
      warning: {
        cloud_unavailable: "Automated evidence assessment unavailable. The reviewer can still inspect the evidence.",
        subject_mismatch: "The before and after photos may not show the same component.",
        low_quality_after: "The after photos are blurry, dark or obstructed. Clearer photos are recommended.",
        new_defect_after: "A defect is visible in the after photos that the work did not cover.",
        detector_disagreement: "The photos point both ways. A person decides.",
        pending_uploads: "Some photos are still uploading and were not assessed.",
        reviewer_required: "A reviewer must approve this work.",
        post_inspection_required: "Pending final inspection.",
      },
      moreEvidenceRequested: "Asked for more photos",
      stale: "Evidence changed. The assessment needs updating.",
      checkEvidence: "Check photos",
      checkAgain: "Check again",
      checking: "Checking completion evidence…",
      checkEvidenceA11y: "Check completion evidence",
      resubmit: "Resubmit",
      resubmitA11y: "Resubmit the completion with the added evidence",
      resubmitted: "Sent back for review. The reviewer has been told.",
      requestEvidence: "Ask for photos",
      requestEvidenceA11y: "Ask for more photos",
      cloudUnavailable: "The automatic photo check is not available right now. Look at the photos and decide.",
      reportEyebrow: "Evidence assessment (automated)",
      editRequirements: "Edit what is needed",
      editSummary: "Checklists, photos and outcomes for this job",
      saved: "Requirements saved. Any earlier assessment now needs updating.",
      suggestFailed: "No suggestions came back. Add outcomes by hand.",
      kind: {
        visual: "Shown in photos",
        meter: "Meter reading",
        document: "Document",
        check: "Checklist",
        note: "Note",
      },
      remove: "Remove",
      removeA11y: "Remove “{{text}}”",
      addOutcomePlaceholder: "Add an expected outcome, e.g. Replacement guard present",
      addOutcome: "Add outcome",
      suggestWithAi: "Suggest with AI",
      saveRequirements: "Save requirements",
      reportPhotosAssessed: "Photos assessed",
      reportRecordsOnly: "Records only",
    },
    closeoutPane: {
      askForPhotos: "Ask for photos",
      viewCompletionReport: 'View completion report',
      emailCloseoutRecipients: "Email the report to the requester",
      sending: 'Sending…',
      waitingOnRequester: 'Waiting on the requester',
      verifyCompletedWork: 'Sign off the completed work',
      requesterGatePendingBody: "The requester checks the work first. Once they confirm they’re happy, tap Verify to close the job. You can still Send back.",
      requesterAcceptedBody: "The requester confirmed they’re happy with the work. Tap Sign off to close the job.",
      reviewAndApproveBody: "Check the note, photos and costs, then Sign off to close the job, or Send back if something needs fixing.",
      requestRework: "Send back",
      rework: "Send back",
      verify: 'Sign off',
      certificateRenewalTitle: 'Certificate renewal',
      certificateRenewalBody: 'Create the replacement certificate from this completed job and link it to the previous certificate.',
      createCertificateFromJob: 'Create certificate from job',
      createCertificate: 'Create certificate',
    },
    assignSheet: {
      chooseContractorsToQuote: "Choose contractors to quote",
      chooseContractor: "Choose a contractor",
      assignToContractor: "Assign to a contractor",
      inviteTeammate: "Invite a teammate",
      close: 'Close',
      youSuffix: '{{name}} (You)',
      searchTeamMembersPlaceholder: 'Search team members…',
      noTeamMemberMatch: 'No team member matches.',
      createTeamHint: "Add a teammate to assign work to them, or assign it to yourself.",
      teammate: 'Assign to a teammate',
      assignToMyself: 'Assign to myself',
    },
  },
  create: {
    skillsTryAgain: "Try again",
    skillsEmpty: "No skills to choose from right now. Tap Try again, or carry on without one.",
    createAndAssignJob: "Create and assign job",
    fromRequestPageTitle: "Confirm job from request",
    checkAttachFailedTitle: "Job created, checklist missing",
    assetLoadFailed: "The linked asset could not be loaded. Check your connection and retry.",
    assetUnavailable: "This asset is unavailable or you no longer have access to it.",
    assetStatus: {
      retired: "Retired",
      archived: "Archived",
      active: "Active",
    },
    visibilityHint: "Private: only you and people on this job. Team: everyone in your team.",
    priorityOption: {
      critical: "Critical",
      high: "High",
      medium: "Medium",
      low: "Low",
    },
    categoryOption: {
      other: "Other",
      replacement: "Replacement",
      inspection: "Inspection",
      maintenance: "Maintenance",
      repair: "Repair",
    },
    unsavedGuard: {
      message: "This job hasn't been created yet. Leave and lose it?",
      discard: 'Leave',
      keep: 'Keep editing',
    },
    assetRetiredTitle: 'Asset retired',
    assetArchivedTitle: 'Asset archived',
    assetRetiredBody: 'This asset has been retired (out of service). Its history stays readable, but it takes no new jobs.',
    assetArchivedBody: 'This asset is archived. You can still view/edit the asset, but cannot create new jobs for it.',
    linkFollowUpFallback: "The request was not updated.",
    checkAttachFailed: "Job created, but the \"{{name}}\" checklist wasn’t added. Open the job and tap Add check.",
    createFailed: "The job was not created. Your details are kept. Check your connection and try again.",
    error: "Something went wrong",
    followUpLinked: 'Follow-up linked to job',
    calendarInviteTitle: 'Job: {{name}}',
    genericAssetFallback: 'Asset',
    recovery: {
      followUpTitle: "Job created, request not updated",
      followUpBody: "{{message}} The job was created. Tap Retry link so the request shows it.",
      retryLink: 'Retry link',
      openJob: 'Open job',
      assetErrorTitle: 'Couldn’t load the linked asset',
      assetLoadingTitle: 'Loading the linked asset…',
      assetErrorBody: '{{error}} Your entered work brief is kept.',
      retryAsset: 'Retry asset',
      requestErrorTitle: "Couldn't load the request",
      requestErrorBody: "This job should be prefilled from the request. Retry to load its details — anything you've already entered is kept.",
      retry: 'Retry',
    },
    createdFromRequest: 'Created from request',
    createdFromAsset: 'Created from asset',
    notSet: 'Not set',
    noPriority: 'No priority',
    openAsset: 'Open asset',
    followOnDetailsTitle: "Follow-up job details",
    workBriefTitle: 'Work brief',
    followOnHint: "Linked to the parent job{{parent}}. It uses the same asset and the same way of getting it done. Assign it and pick a date once it is approved.",
    workPathTitle: "Who does it?",
    linkAssetLabel: 'Link to asset (optional)',
    selectAssetPlaceholder: 'Select asset',
    titleLabel: 'Title',
    titlePlaceholder: 'e.g. Fix leaking faucet',
    titleError: 'Enter a job title to continue.',
    descriptionLabel: 'Describe the issue (optional)',
    descriptionPlaceholder: 'What needs to be done? Add details so the assignee has context.',
    dictateStop: 'Stop',
    dictateStart: 'Dictate',
    cleaningUp: "Tidying up…",
    aiCleanUp: "Tidy up with AI",
    photosLabel: 'Photos (optional, max 3)',
    completionEvidence: {
      title: "Completion evidence",
      summary: "What proof of the finished work this job needs",
      beforePhoto: "Before photo",
      afterPhoto: "After photo",
      level: {
        none: "Not needed",
        recommended: "Recommended",
        required: "Required",
      },
      reviewerRequired: "Reviewer must approve",
      postInspection: "Post-work inspection",
      requiredHint: "Required evidence blocks completion until it is added.",
      recommendedHint: "Recommended evidence warns but never blocks.",
    },
    categoryLabel: 'Category *',
    categoryError: 'Choose a category to continue.',
    skillsOptionalLabel: 'Skills (optional)',
    requiredSkillsLabel: 'Required skills',
    requiredSkillsError: "Choose at least one skill for the follow-up job. The parent job’s skills are filled in when it has them.",
    requiredSkillsHint: "Choose at least one skill. The parent job’s skills are filled in when it has them.",
    addContext: 'Add context (optional)',
    priorityLabel: 'Priority',
    locationLabel: 'Location (optional)',
    locationPlaceholder: 'Search address…',
    assignScheduleTitle: 'Assign and schedule',
    assignScheduleSummary: 'Due date, schedule and assignee',
    dueDateLabel: 'Due date (optional)',
    selectDatePlaceholder: 'Select date',
    dueDateHint: 'Target completion date. Leave scheduling blank if this work does not need a specific slot yet.',
    scheduledDateLabel: 'Scheduled date (optional)',
    planDatePlaceholder: 'Plan date',
    startTimeLabel: 'Start time',
    selectTimePlaceholder: 'Select time',
    estimatedDurationLabel: 'Estimated duration',
    suggestedDuration: 'Suggested: {{duration}} ({{reason}})',
    useSuggestedDuration: 'Use the suggested duration',
    applied: 'Applied',
    useSuggestion: 'Use suggestion',
    plannedPreview: 'Planned: {{preview}}',
    clearSchedule: 'Clear schedule',
    inviteLabel: 'Invite (optional)',
    setDateHint: 'Set a date to plan when the work should start.',
    quotesContractorHint: 'You choose which contractors to invite to quote after the job is created.',
    directContractorHint: 'You choose the contractor after the job is created.',
    assignTeamMemberLabel: 'Assign to team member (optional)',
    searchTeamMembersPlaceholder: 'Search team members…',
    noTeamMemberMatch: 'No team member matches.',
    assignSuggestedMember: 'Assign the suggested member, {{name}}',
    suggestedAssignee: 'Suggested: {{name}}',
    assignAnytimeHint: 'Assign now or assign after the job is created.',
    advancedSettingsTitle: 'More details',
    advancedSettingsSummary: 'Category, duration, checks, calendar invite, cost and visibility',
    estimatedCostLabel: 'Estimated cost (optional)',
    estimatedCostAmount: 'Estimated cost amount',
    visibilityLabel: 'Visibility',
    submitting: 'Submitting…',
    submitForApproval: 'Submit for approval',
    creating: 'Creating…',
    createJob: 'Create job',
    followOnPageTitle: "Propose a follow-up job",
    createPageTitle: 'Create job',
    followOnSubtitle: "It waits for approval before it can be assigned.",
    requestSubtitle: "Check the details, choose who does it and by when, then tap Create and assign job.",
    manualSubtitle: 'Describe the work and choose a category. You can assign and schedule it next.',
    linkAssetSheetTitle: 'Link to asset',
    noneOption: 'None',
    openLinkedAsset: 'Open linked asset',
    cleanedDescriptionTitle: 'Cleaned-up description',
    cleaningUpDescription: 'Cleaning up description',
    reviewSuggestedWording: 'Review the suggested wording before applying it.',
    unableToCleanUpTitle: 'Unable to clean up description',
    tryAgain: 'Please try again.',
  },
  recurring: {
    addStepNote: "This plan becomes step {{n}} of {{name}}.",
    saved: {
      dateInspection: "Plan saved. The first inspection appears in Work on {{when}}.",
      dateJob: "Plan saved. The first job appears in Work on {{when}}.",
      meterInspection: "Plan saved. The first inspection appears in Work when the meter reaches {{amount}}.",
      meterJob: "Plan saved. The first job appears in Work when the meter reaches {{amount}}.",
      eitherInspection: "Plan saved. The first inspection appears in Work at {{amount}} or on {{when}}, whichever comes first.",
      eitherJob: "Plan saved. The first job appears in Work at {{amount}} or on {{when}}, whichever comes first.",
      conditionInspection: "Plan saved. An inspection appears in Work when the condition score drops to {{score}} or below.",
      conditionJob: "Plan saved. A job appears in Work when the condition score drops to {{score}} or below.",
      manual: "Plan saved. Nothing appears in Work until someone presses Start now on the asset's Maintenance tab.",
      needsReading: "Plan saved. Record a meter reading on the asset so it can start counting.",
      nowInspection: "Plan saved. The first inspection is in Work now.",
      nowJob: "Plan saved. The first job is in Work now.",
      generic: "Plan saved. You'll find it on the asset's Maintenance tab.",
    },
    skipPolicy: {
      hint: {
        not_allowed: "A visit can be moved or handed on, but never skipped.",
        no_approval: "Whoever does the work can skip a visit straight away. The asset's approvers are told.",
        team_admin: "Only a team owner or admin can agree to skip a visit.",
        requires_approval: "Someone can ask to skip or move a visit; one of the asset's approvers decides.",
        default: "Not chosen: a manager decides — a team admin when the asset has a compliance duty.",
      },
      not_allowed: "Never skip",
      no_approval: "Skip without asking",
      team_admin: "A team admin decides",
      requires_approval: "A manager decides",
      label: "If a visit can't be done",
    },
    meterNowHint: "Saved as the first reading, so the plan knows where to count from.",
    meterNow: "What the meter reads now",
    createTemplate: "Create a checklist",
    noTemplates: "No checklists yet. Create one and it is chosen here for you.",
    addDocument: "Add a document",
    pickAssetFirst: "Choose the asset first; then pick one of its documents.",
    cannotManage: "You can't add plans to {{asset}}. Ask its owner or a team admin.",
    assetPickerSubtitle: "A plan belongs to one asset. Its work appears in Work against that asset.",
    maintenanceSave: "Create plan",
    maintenanceSuccessTitle: "Plan created",
    maintenanceSuccessBody: "Work is raised when the plan falls due. Manage it from the asset’s Maintenance tab.",
    maintenanceHeading: "Maintenance plan",
    maintenanceSub: "Work that comes back — a service, a test or an inspection. Choose the asset, say what gets done and when it is due. The job appears in Work each time it is due.",
    modeWhenDue: "When it's due",
    repeatEvery: 'Repeat by date',
    everyCount: 'Every',
    unit: { hours: 'hours', days: 'days', weeks: 'weeks', months: 'months', years: 'years' },
    edit: {
      loadFailed: "This plan could not be opened. Check your connection and try again.",
      heading: 'Edit plan',
      sub: 'Changes apply from the next time the plan comes round. Work already raised is unchanged.',
      save: 'Save changes',
      savedTitle: 'Plan updated',
      savedBody: 'The change applies from the next time the plan comes round. Work already raised is unchanged.',
      notFound: 'This plan could not be found. It may have been ended.',
      conflict: "Someone else saved this plan after you opened it. Your changes were not applied — go back, open it again and redo them.",
    },
    meterEvery: 'Repeat by meter',
    meterInterval: 'Every',
    meterKind: { mileage: 'Mileage', operating_hours: 'Hours', cycles: 'Cycles' },
    meterCurrent: 'The meter reads {{amount}} now.',
    meterNoReading: 'No reading yet — record one on the asset so the plan has something to count from.',
    whicheverFirst: 'Whichever comes first',
    lastDone: 'Last done (optional)',
    lastDoneDate: 'Date',
    lastDoneTime: 'Time',
    lastDoneMeter: 'Meter at last service',
    lastDoneHint: 'Leave blank to count from today and the current reading.',
    moreOptions: "More options",
    meterAlso: "Also repeat by meter reading",
    meterRemove: 'Remove meter repeat',
    unitPickerTitle: "Repeat every",
    lastDoneHintNow: "Leave blank if never done.",
    whoDoesIt: "Who does it (optional)",
    nobodyYet: "Decide each time",
    whoDoesItHint: "Each visit is given to {{name}}, who is told when it arrives.",
    nobodyYetHint: "Each visit arrives up to two weeks before it is due, and you are asked to assign it — and reminded 3 days before.",
    assetPlaceholder: 'Choose an asset',
    firstRunDatePlaceholder: 'Date',
    firstRunTimePlaceholder: 'Time',
    ok: 'OK',
    unsavedGuard: {
      editMessage: 'Your changes to this plan are not saved. Leave and lose them?',
      createMessage: "This plan is not saved yet. Leave and lose it?",
      discard: 'Leave',
      keep: 'Keep editing',
    },
    doItAs: 'Do it as',
    asJob: 'Job',
    asInspection: 'Inspection',
    pickTemplate: 'Choose a checklist',
    serviceReading: 'Meter reading at service',
    useReading: 'Use {{amount}} as the service reading',
    heading: 'Maintenance plan',
    sub: 'Creates the next job for you on a schedule — after each one finishes, or on the calendar date.',
    asset: 'Asset',
    title: "What gets done",
    titlePh: "e.g. Annual service",
    description: "Details (optional)",
    descriptionPh: "What to do each time",
    category: 'Category',
    firstRun: 'First run (date & time)',
    recurrence: 'Repeat',
    advanceMode: 'How should the next job be created?',
    modeCompletion: 'After prior job finishes',
    modeCalendar: 'On calendar due date',
    modeHint: {
      when_due: 'The next job appears when the date or the meter says so — whichever comes first. Nothing is created until then.',
      on_completion: 'The next job appears after you complete or cancel the current one in this series.',
      on_calendar: 'A new job is created when each due date arrives, even if the previous job is still open (unless you enable skip below).',
    },
    skipIfPriorOpen: "Skip the next one if the last one is still open",
    seriesLimits: "Stop repeating (optional)",
    seriesLimitsHint: "Leave both blank to keep it repeating.",
    endDate: 'End by date',
    endTime: 'End time',
    checksHint: "Added to every job this plan raises.",
    maxJobs: "Stop after this many jobs",
    maxPh: 'No limit',
    save: 'Create series',
    saving: 'Creating…',
    successTitle: 'Series created',
    successBody: 'The first job is in Work; the next ones follow your schedule.',
    errorTitle: "Plan not saved",
    footer: 'Asset: {{asset}}',
    errors: {
      meterNowFailed: "That reading could not be saved. Check the number and try again.",
      meterNow: "Enter what the meter reads now.",
      every: 'Enter how often, as a whole number.',
      meter: 'Enter how often, in {{unit}}.',
      noLeg: 'Add a repeat by date, by meter, or both.',
      template: 'Choose a checklist for the inspection.',
      lastDone: 'Pick a valid last-done date, or leave it blank.',
      lastDoneMeter: 'Enter the reading at the last service, or leave it blank.',
      readingLower: 'The service reading is lower than the current {{amount}}.',
      asset: "Choose the asset this plan is for.",
      title: "Say what gets done.",
      datetime: 'Pick a valid first run date and time.',
      endInvalid: "Pick a valid stop date.",
      endBeforeStart: "The stop date must be on or after the first one.",
      max: "Enter how many jobs, or leave it blank.",
      generic: "Your plan was not saved. Check your connection and try again.",
    },
    serviceReadingHint: "The next service counts from this reading.",
    dueBy: "When is it due?",
    trigger: {
      schedule: "Every…",
      fixed_date: "On set dates",
      document_renewal: "When a document expires",
      condition: "When condition drops",
      manual: "No schedule, I start it",
    },
    triggerHint: {
      fixed_date: "Work is raised on each date.",
      document_renewal: "Work is raised when the document expires. Filing its renewal moves the plan on to the new expiry.",
      condition: "Work is raised when the asset's condition score drops to this or below.",
      manual: "Nothing is raised on its own. Start it from the asset's Maintenance tab when it is needed.",
    },
    dates: "Dates",
    addDate: "Add a date",
    removeDate: "Remove this date",
    pickDocument: "Choose a document",
    documentExpires: "{{title}} · expires {{when}}",
    noDocuments: "This asset has no document with an expiry date yet. Add one, then come back and choose it.",
    conditionScore: "Condition score (0–100)",
    errorDates: "Add at least one date.",
    errorDocument: "Choose the document whose expiry makes this due.",
    errorCondition: "Enter a condition score from 0 to 100.",
  },
  handoff: {
    couldNotLoadTeam: "The team could not be loaded. Check your connection and tap Retry.",
    assignToMyself: "Assign to myself",
    inviteTeammate: "Invite a teammate",
    createdSubtitleAssigned: "It’s in Work now and assigned to {{name}}. Pick a date once they accept it.",
    createdSubtitle: "It’s in Work now. Choose who does it and when. They’ll be told when you assign them.",
    createdTitle: "Job created",
    assignTitle_other: "Assign the jobs",
    assignTitle_one: "Assign the job",
    pageTitle: "Assign the job",
    releaseFollowUpTitle: "Approve the follow-up job",
    releaseSubtitle: "Approve it, choose who does it, and pick a date.",
    batchSubtitle: "Choose who does each job and when. They’ll be told when you assign them.",
    emptyTitle: "No jobs to assign",
    emptyBody: "There are no jobs here to assign. Go back to Work to find new ones.",
    backToWork: 'Back to work',
    releaseHandoffTitle: "Approve and assign",
    smoothHandoffTitle: "Assign each job",
    releaseIntroText: "Each card shows who asked for the work, who does it, when, and who gets the finished report. Approving lets it be assigned and given a date.",
    batchIntroText: "Each card shows who asked for the work, who does it, when, and who gets the finished report. After you assign one, the next one scrolls into view.",
    applyToAllJobs: 'Apply to all {{count}} jobs',
    scheduleAllJobsTogether: 'Schedule all jobs together',
    scheduleTogether: 'Schedule together',
    setWorkPathToAllJobs: "Set every job to: {{mode}}",
    allInternal: "All to our team",
    allToContractor: "All to a contractor",
    allToQuotes: "Get quotes for all",
    pendingRelease: "Needs approval",
    requester: 'Requester',
    noRequesterLinked: 'No requester linked yet',
    requesterNoneLinked: "No requester linked, so only your team gets the report.",
    assigneeLine: 'Assignee: {{name}}',
    setOnRelease: "Chosen when approved",
    verbAssignToTeam: 'assign to team',
    verbAssignToContractor: 'assign to contractor',
    verbRequestQuotes: 'request quotes',
    approveAndVerb: "Approve and {{verb}}",
    changeAssignee: 'Change assignee',
    workPathLabel: "Who does it?",
    assigneeLabel: 'Assignee',
    plannedDateLabel: 'Planned date',
    completionRecipientsLabel: "Who gets the finished report",
    requiredSkillsLabel: 'Required skills',
    notScheduledYet: 'Not scheduled yet',
    awaitingAcceptance: '{{name}} · awaiting acceptance',
    notAssignedYet: 'Not assigned yet',
    assignToName: "Assign to {{name}}",
    someoneElse: "Someone else",
    sourceContractorHint: "{{name}} did the job this came from.",
    awaitingNote: "You can pick a date once they accept it",
    changeDate: "Change date",
    planDate: "Pick a date",
    viewJobLabel: 'View job {{title}}',
    viewJob: 'View job',
    doneBackToRequest: 'Done · Back to the request',
    doneBackToAsset: 'Done · Back to asset',
    doneBackToJobs: 'Done · Back to jobs',
    doneOpenJob: 'Done · Open job',
    assignToTeamMemberTitle: 'Assign to team member',
    teamHintNoTeamAsset: 'This asset is not linked to a team — using personal assignment. You can assign the job to yourself.',
    teamHintNoTeamJob: 'No team is set on this job — personal assignment. You can assign the job to yourself.',
    teamHintUsingTeam: 'Using team that manages this job or asset: {{name}}',
    teamHintUsingWorkspaceTeam: 'Using the workspace team linked to this job or asset.',
    loadingTeamMembers: 'Loading team members…',
    retry: 'Retry',
    noTeamMembersTitle: "Nobody else on the team yet",
    noTeamMembersBody: "Add a teammate to assign work to them, or assign it to yourself.",
    refresh: 'Refresh',
    unnamedMember: 'Unnamed member',
    youSuffix: ' (You)',
    scheduleJobsTogetherTitle: 'Schedule {{count}} jobs together',
    planHandoffDateTitle: "When will it be done?",
    scheduleTogetherText: 'The same date, time, and estimated duration will be applied to every eligible job in this batch.',
    planHandoffDateText: "Pick the day and time the work should happen.",
    dateLabel: 'Date',
    timeLabel: 'Time',
    estimatedDurationLabel: 'Estimated duration',
    cancel: 'Cancel',
    saveForJobs: 'Save for {{count}} jobs',
    saveDate: "Save date",
    chooseContractorsForQuotes: 'Choose contractors for quotes',
    assignToContractorTitle: 'Assign to contractor',
    addContractor: 'Add contractor',
    error: "Something went wrong",
    failedApplyWorkPathAll: "Not every job was changed. Check your connection and try again.",
    failedUpdateWorkPath: "Who does it was not saved. Check your connection and try again.",
    failedAssign: "The job was not assigned. Check your connection and try again.",
    failedReleaseFollowUp: "The follow-up job was not approved. Check your connection and try again.",
    failedScheduleJobsTogether: "The dates were not saved. Check your connection and try again.",
    failedSchedule: "The date was not saved. Check your connection and try again.",
    noTeamTitle: "No team for this job",
    noTeamBody: "We could not tell which team this job belongs to, so the contractor was not invited. Check your connection and try again.",
    assignedTitle: "Assigned, but the email did not go",
    assignedInviteFailedBody: "The job is theirs, but the invite email could not be sent. Let them know yourself.",
    plannedDateRequiredTitle: 'Planned date required',
    plannedDateRequiredBody: 'Choose a planned date before saving.',
    nothingToScheduleTitle: 'Nothing to schedule',
    nothingToScheduleBody: 'No jobs in this batch are ready to be scheduled yet.',
    mustBeAcceptedError: "The job must be accepted before you can pick a date.",
  },
  updates: {
    audienceEveryone: "Everyone on this job",
    audienceTeam: "Only my team",
    failedToPostUpdate: "The update was not posted. Check your connection and try again.",
    failedToSend: "Your update was not sent. Check your connection and try again.",
    quickPosted: "Update posted. It shows in this job’s activity.",
    quick: {
      follow_up_required: {
        note: "A follow-up job is needed.",
        label: "Needs a follow-up job",
      },
      completed_successfully: {
        note: "The work is done.",
        label: "Work done",
      },
      additional_issue_found: {
        note: "Found another problem while doing the work.",
        label: "Found another problem",
      },
      awaiting_access: {
        note: "Can’t carry on: waiting for access to the site.",
        label: "Waiting for access",
      },
      awaiting_parts: {
        note: "Waiting for parts before the work can carry on.",
        label: "Waiting for parts",
      },
      work_in_progress: {
        note: "Work in progress.",
        label: "Work in progress",
      },
      arrived_on_site: {
        note: "Arrived on site.",
        label: "Arrived on site",
      },
    },
    pageTitle: 'Updates',
    jobFallback: 'Job',
    suggestedUpdateTitle: 'Suggested update',
    accept: 'Accept',
    expandedUpdate: 'Expanded update',
    improvedUpdate: 'Improved update',
    unableToExpandNote: 'Unable to expand note',
    unableToImproveNote: 'Unable to improve note',
    reviewGeneratedWording: 'Review the generated wording before applying it to the update.',
    photoAccessRequiredTitle: 'Photo access required',
    photoAccessRequiredBody: 'Allow photo library access to attach an image.',
    photoNotSavedTitle: 'Photo was not saved',
    photoNotSavedFallback: 'Could not save this photo on the device.',
    activityLoadErrorTitle: 'Activity could not be loaded. Try again.',
    tryAgain: 'Try again',
    loadingActivity: 'Loading activity',
    emptyActivity: 'No activity yet. Updates, comments, assignments, and status changes will appear here.',
    internalBadge: 'Internal',
    savedOnThisDevice: 'Saved on this device',
    showingRecentUpdates: 'Showing the most recent 100 saved updates.',
    showingSavedActivity: 'Showing saved activity.',
    lastRefreshed: 'Last refreshed {{date}}. Photos may need a connection.',
    refreshActivity: 'Refresh activity',
    refreshing: 'Refreshing…',
    quickUpdates: 'Quick updates',
    attachPhoto: 'Attach a photo',
    startUpdatePlaceholder: 'Start an update...',
    jobUpdateLabel: 'Job update',
    internalToggleOn: "Only your team sees this note; the contractor does not. Tap to show it to everyone on this job.",
    internalToggleOff: "Everyone on this job sees this note. Tap to keep it to your team.",
    sendUpdate: 'Send update',
    improving: 'Improving...',
    improveNote: 'Improve note',
    expanding: "Adding detail…",
    expandNote: "Add detail with AI",
    aiCleanup: 'AI cleanup',
    connectOnceHint: 'Connect once to open this workspace before saving updates.',
    openingWorkspace: 'Opening your workspace…',
    updatesSavedOnDevice_one: '{{count}} update saved on this device.',
    updatesSavedOnDevice_other: '{{count}} updates saved on this device.',
    photosSavedOnDevice_one: '{{count}} photo saved on this device.',
    photosSavedOnDevice_other: '{{count}} photos saved on this device.',
    syncNeedsAttention: 'Synchronization needs attention.',
    waitingToSynchronize: 'Waiting to synchronize.',
    reviewSynchronization: 'Review synchronization',
    syncFailed: "Not sent. Check your connection and try again.",
    couldNotSyncActivity: 'Could not sync job activity.',
    jobPhoto: 'Job photo',
  },
  checkRunner: {
    jobStarted: "Job started. Tap Complete when the work is done.",
    couldNotStartTitle: 'Couldn’t start the job',
    tryAgain: 'Try again.',
    checkFallbackTitle: 'Check',
    stepWord_one: 'step',
    stepWord_other: 'steps',
    jobStartsWhenDone: 'Job starts when done',
    finishPrecheckAndStart: 'Finish precheck and start job',
    doneBackToJob: 'Done — back to the job',
  },
  quotes: {
    inclTax: "incl. tax",
    declinedLine: "{{name}} declined: {{reason}}",
    pageTitle: 'Compare quotes',
    inviteOnly: 'Invite-only',
    contractorFallback: 'Contractor',
    durationNotProvided: 'Duration not provided',
    priceDeltaVsLowest: '+{{amount}} vs lowest',
    durationDeltaVsFastest: '+{{duration}} vs fastest',
    compareQuotesAction: 'Compare quotes',
    recommendOne: 'Recommend one',
    jobTitleFallback: "Quote request",
    jobNotFound: 'Job not found.',
    awardQuoteConfirmTitle: 'Award {{name}}?',
    priceDurationLine: '{{price}} | {{duration}}',
    aiRecommendationFavors: 'AI recommendation currently favors this quote.',
    awardConsequence: "The job goes to {{name}} straight away. Every other quote is declined and those contractors are told.",
    awarded: "Quote accepted. The job is now {{name}}'s, and the other contractors who quoted have been told.",
    acceptFailedTitle: "Couldn't accept the quote",
    acceptFailedBody: 'The quote was not accepted. Refresh this page to see if it was already decided, then try again.',
    rejectFailedTitle: "Couldn't reject the quote",
    rejectFailedBody: 'The quote was not rejected. Refresh this page, then try again.',
    acceptQuoteFallbackMessage: 'Accept this quote and update the job with contractor, expected cost, and expected duration?',
    awardQuoteTitle: 'Award quote',
    cancel: 'Cancel',
    award: 'Award',
    error: 'Error',
    failedAcceptQuote: 'Failed to accept quote',
    rejectQuoteConfirmTitle: "Reject {{name}}'s quote?",
    decisionTrackedNotify: 'This decision is tracked and can notify the contractor.',
    rejectQuoteFallbackMessage: 'Reject this quote? The contractor can be notified and this decision is tracked.',
    rejectQuoteTitle: 'Reject quote',
    reject: 'Reject',
    failedRejectQuote: 'Failed to reject quote',
    aiQuoteIntelligenceTitle: 'AI quote intelligence',
    aiGroundedHint: 'Grounded only in submitted quote fields. Review before making a final decision.',
    generatingAiInsights: 'Generating AI insights...',
    refreshAiInsights: 'Refresh AI insights',
    generateAiInsights: 'Generate AI insights',
    lastUpdated: 'Last updated: {{date}}',
    comparisonInsightsLabel: 'Comparison insights',
    notableDifferencesLabel: 'Notable differences',
    bestValueSuggestionLabel: 'Best-value suggestion (assistive)',
    suggestedQuote: 'Suggested quote: {{name}}',
    noSingleQuoteSuggested: 'No single quote suggested yet (insufficient evidence).',
    cautionLine: 'Caution: {{caution}}',
    confidenceLine: 'Confidence: {{confidence}}',
    unableToGenerateAiInsights: 'Unable to generate AI insights.',
    comparisonSummaryLabel: 'Compare quotes',
    priceRangeLine: 'Price range: {{low}} to {{high}}',
    priceDataUnavailable: 'Price data unavailable.',
    durationRangeLine: 'Duration range: {{fast}} to {{slow}}',
    durationDataUnavailable: 'Duration data unavailable.',
    jobContextLabel: 'Job context',
    assetLine: 'Asset: {{name}}',
    noLinkedAsset: 'No linked asset',
    locationLine: 'Location: {{value}}',
    categoryLine: 'Category: {{value}}',
    urgencyLine: 'Urgency: {{value}}',
    requestProgressLabel: 'Request progress',
    inviteSummaryLine: '{{invited}} invited · {{submitted}} submitted · {{declined}} declined',
    inviteSummaryPendingSuffix: ' · {{pending}} pending',
    responseDeadlineLine: 'Response deadline: {{date}}',
    targetWindowLine: 'Target window: {{start}} to {{end}}',
    budgetLine: 'Budget: {{value}}',
    scopeLabel: 'Scope',
    noOpenQuotesTitle: 'No open quotes to decide',
    noOpenQuotesBody: 'Invited contractors can submit quotes. Decisions appear here.',
    allDeclinedBody: "Everyone you asked has declined. Invite more contractors to get a price.",
    headerContractor: 'Contractor',
    headerPrice: 'Price',
    headerDuration: 'Duration',
    headerAvailability: 'Availability',
    headerScopeExclusions: 'Scope / exclusions',
    headerAiSummary: 'AI summary',
    scopeResponseMissing: 'Scope response missing',
    missingLine: 'Missing: {{items}}',
    completeResponse: 'Complete response',
    bestPriceChip: 'Best price',
    fastestChip: 'Fastest',
    aiRecommendedChip: 'AI recommended',
    runAiInsightsToGenerateSummary: 'Run AI insights to generate summary.',
    acceptedQuoteLabel: 'Accepted quote',
    rejectedQuotesLabel: 'Rejected quotes',
    reasonLine: 'Reason: {{reason}}',
    selectQuoteTitle: 'Select a quote',
    selectQuoteBody: 'Pick a quote row to inspect details, AI insights, and award decisions.',
    rejecting: 'Rejecting...',
    awarding: 'Awarding...',
    awardQuoteAction: 'Award quote',
    openJob: 'Open job',
    bestPriceAndFastest: 'Best price and fastest',
    fastestDuration: 'Fastest duration',
    submittedQuoteStatus: 'Submitted quote',
    applyingDecision: 'Applying decision…',
    aiIntelligenceLabel: 'AI intelligence',
    includedLabel: 'Included',
    excludedLabel: 'Excluded',
    caveatsLabel: 'Caveats',
    aiSummaryIncludedLine: 'Included: {{items}}',
    aiSummaryExcludedLine: 'Excluded: {{items}}',
    aiSummaryCaveatsLine: 'Caveats: {{items}}',
    recommendationLabel: 'Recommendation',
    recommendationValue: '{{name}} ({{confidence}})',
    noneFallback: 'None',
    whatsIncludedHeading: "What's included",
    notProvidedFallback: 'Not provided',
    materialsLabel: 'Materials',
    notIncludedFallback: 'Not included',
    warrantyLabel: 'Warranty',
    availabilityRangeArrow: '{{start}} → {{end}}',
    exclusionsLabel: 'Exclusions',
    evidenceLabel: 'Evidence',
    missingInfoLine: 'Missing information: {{items}}',
    linkedContextHeading: 'Linked context',
    jobLabelKv: 'Job',
    assetLabelKv: 'Asset',
    noScopeProvided: 'No scope provided',
    requestNotesLabel: 'Request notes',
    noNotesProvided: 'No notes provided',
    inviteMoreContractors: 'Invite more contractors',
    scopeResponseLine: "What it covers: {{value}}",
    durationLine: 'Duration: {{value}}',
    availabilityToLine: 'Availability: {{start}} to {{end}}',
    exclusionsLine: "Includes: {{value}}",
    evidenceLine: 'Evidence: {{value}}',
    warrantyLine: 'Warranty: {{value}}',
    attachmentsLine: 'Attachments: {{count}}',
    aiSummaryLabel: 'AI summary',
    fastestDurationChip: 'Fastest duration',
    acceptQuote: 'Accept quote',
  },
  share: {
    relationshipChangeA11y: "Change their relationship to the asset",
    relationshipChange: "Change",
    relationship: "Their relationship: {{role}}",
    openJob: "Open job",
    editContactDetails: "Edit contact details",
    copyLink: "Copy link",
    emailNotSent: "Shared, but the email did not send. Copy the link to send it yourself.",
    checkDetails: "Check the contact, role and email, then tap Send again.",
    emailRequired: "Enter their email address. The link to the report goes there.",
    roleRequired: "Choose who they are, for example Requester.",
    addEmail: "Add email",
    chooseRole: "Choose role",
    chooseContact: "Choose a contact",
    jobFallback: 'Job',
    couldNotLoadReport: 'Could not load this report. Try again.',
    greetingDefault: 'Hi,\n\nPlease find the job completion report for {{name}}. The work has been finished and documented for your records.\n\nThank you.',
    loadingReport: 'Loading report',
    tryAgain: 'Try again',
    jobNotFound: 'Job not found',
    onlyOwnerCanShare: "Only the job owner or a member of the asset's team can share the completion report.",
    goBack: 'Go back',
    completeAndVerifyFirst: "Finish this job before sharing its report.",
    error: 'Error',
    jobNotFoundBody: 'Job not found.',
    notReadyTitle: 'Not ready',
    notReadyBody: "Finish this job before sharing its report.",
    checkPhoneTitle: 'Check the phone number',
    checkPhoneBody: 'Enter a valid number for the selected country, or leave the phone empty.',
    resent: 'Resent',
    sent: 'Sent',
    resentBody: "Report sent again. They get a new email with the link.",
    sentBody: "Report sent. They get an email with a link to look over the work.",
    emailErrorLine: '\n\nError: {{error}}',
    emailFailedBody: 'Could not send the email. Share the review link manually:\n{{link}}{{errorLine}}',
    shareCreatedTitle: 'Share created',
    shareCreatedBody: 'Share this link:\n{{link}}',
    failedToCreateShare: "The report was not shared. Check your connection and try again.",
    devLinkWarning: "Share links use localhost and won't work for recipients. Add EXPO_PUBLIC_WEB_APP_URL to your .env (your deployed app URL) and restart.",
    prodLinkWarning: "A shareable web link isn't set up for this workspace yet, so recipients may not be able to open the report link. Please contact your administrator.",
    shareToLabel: "Send to",
    shareToHint: "Tap Select contact and pick the person. People you sent this to before are at the top.",
    whoCanOpen: "Only they can open the report. The link in their email signs them straight in. Anyone else who gets the link can only ask you for access.",
    changeContact: 'Change contact',
    selectContact: 'Select contact',
    contactFallback: 'Contact',
    noEmailOrPhone: 'No email or phone',
    shareToContactTitle: "Send to",
    howToSendLabel: 'How to send',
    shareViaLabel: 'Share via',
    emailMethodLabel: 'Email',
    roleLabel: 'Role *',
    recipientNameLabel: "Their name (optional)",
    recipientNamePlaceholder: 'e.g. John Smith',
    recipientEmailLabel: "Their email *",
    recipientEmailAria: "Their email (required)",
    recipientEmailPlaceholder: 'client@example.com',
    phoneOptionalLabel: 'Phone (optional)',
    shareStatusLabel: "Already sent",
    firstSharedLine: "Already sent on {{date}}",
    lastResharedLine: "Sent again on {{date}}",
    noResponseByDeadline: "No reply by the date you set. Tap Send again to remind them.",
    responseDeadlineLabel: "Reply by (optional)",
    selectDatePlaceholder: 'Select date',
    messageOptionalLabel: 'Message (optional)',
    messagePlaceholder: 'Add a note for the recipient...',
    actualCostOnReport: 'Actual cost on report: {{amount}}',
    sending: 'Sending…',
    resend: "Send again",
    send: "Send report",
    cancel: 'Cancel',
    couldNotShareReportTitle: 'Could not share report',
    sharingFailedFallback: 'Sharing failed. Check your connection and try again.',
  },
  requestQuotes: {
    includedItemsHeading: 'Included items:',
    excludedOrAssumptionsHeading: 'Excluded or assumptions:',
    clarificationQuestionsHeading: 'Clarification questions:',
    addNotesFirstTitle: 'Add notes first',
    addNotesFirstBody: 'Type or dictate notes, then use AI to rewrite them.',
    couldNotRewriteNotesTitle: 'Could not rewrite notes',
    tryAgain: 'Please try again.',
    applyAiScopeDraftTitle: 'Apply AI scope draft',
    applyAiScopeDraftBody: 'You already have scope text. Replace it or append the AI draft?',
    cancel: 'Cancel',
    append: 'Append',
    replace: 'Replace',
    unableToGenerateScopeTitle: 'Unable to generate scope',
    selectContractorsTitle: 'Select contractors',
    selectContractorsBody: 'Choose at least one contractor to invite.',
    quoteRequestSent_one: "Quote request sent to {{count}} contractor. You'll be told as quotes come in. Compare them from this job.",
    quoteRequestSent_other: "Quote request sent to {{count}} contractors. You'll be told as quotes come in. Compare them from this job.",
    error: 'Error',
    failedToSendQuoteRequest: 'Failed to send quote request',
    sendFailedTitle: "Couldn't send the quote request",
    sendFailedBody: 'The quote request was not sent. Your entries are still here, so try again in a moment.',
    noEmailNote: "No email, so they won't get this. Add one on their contact page.",
    jobNotFound: 'Job not found.',
    notPrivateQuotesBody: 'This job is set to go to one person. To ask several contractors for a price, tap Ask for quotes instead.',
    notPrivateQuotesLockedBody: "This job is set to go to one person, so it can't go out for quotes now.",
    switchToQuotes: 'Ask for quotes instead',
    switchingToQuotes: 'Switching…',
    switchFailedTitle: "Couldn't switch to quotes",
    switchFailedBody: "The job wasn't changed. Try again in a moment.",
    backToJob: 'Back to the job',
    goBack: 'Go back',
    jobTitleFallback: "Quote request",
    pageTitle: 'Request quotes',
    inviteOnly: 'Invite-only',
    inviteTrustedHint: 'Invite trusted contractors from your directory. This is not a public listing.',
    scopeDescriptionLabel: 'Scope / description',
    scopeDescriptionPlaceholder: 'What work is required?',
    generatingScope: 'Generating...',
    aiScope: 'AI scope',
    notesOptionalLabel: 'Notes (optional)',
    notesOptionalPlaceholder: 'Additional context for contractors',
    rewriting: 'Rewriting...',
    rewrite: 'Rewrite',
    aiScopeDraftDetailsTitle: 'AI scope draft details',
    includedLine: 'Included: {{items}}',
    excludedLine: 'Excluded: {{items}}',
    questionsLine: 'Questions: {{items}}',
    responseDeadlineLabel: 'Response deadline (optional)',
    respondByPlaceholder: 'When should they respond by?',
    responseTimeLabel: 'Response time (optional)',
    selectTimePlaceholder: 'Select time',
    targetStartLabel: 'Target start (optional)',
    earliestStartPlaceholder: 'Earliest start date',
    targetEndLabel: 'Target end (optional)',
    latestEndPlaceholder: 'Latest end date',
    estimatedBudgetLabel: 'Estimated budget (optional)',
    photosLabel: 'Photos (optional, max 3)',
    selectContractorsLabel: 'Select contractors to invite *',
    selectContractorsHint: 'Search your contacts and optionally filter by skill or scope. No one is pre-selected for you.',
    requiredSkillsLabel: 'Required skills',
    addOrChangeContractors: 'Add or change contractors',
    chooseContractors: 'Choose contractors',
    selectedCount: 'Selected · {{count}}',
    declinedToQuote: 'Declined to quote',
    quoteSubmitted: 'Quote submitted',
    alreadyInvited: 'Already invited — awaiting their answer',
    removeContact: 'Remove {{name}}',
    noContractorsSelected: 'No contractors selected yet.',
    creating: 'Creating…',
    sending: 'Sending…',
    everyoneAlreadyInvited: 'Everyone selected is already invited',
    sendToMore_one: 'Send to {{count}} more contractor',
    sendToMore_other: 'Send to {{count}} more contractors',
    sendTo_one: 'Send to {{count}} contractor',
    sendTo_other: 'Send to {{count}} contractors',
    chooseContractorsForQuotesTitle: 'Choose contractors for quotes',
    addContractor: 'Add contractor',
  },
  /** The contractor's own screen for one quote invitation (app/quote-requests/[inviteId]). */
  quoteInvite: {
    brief: {
      forClient: "For {{name}}",
      replyBy: "Reply by {{date}}",
      budget: "Budget {{amount}}",
      starts: "Start {{date}}",
      finishBy: "Finish by {{date}}",
      due: "Due {{date}}",
      whatTheyNeed: "What they need",
      where: "Where",
      route: "Route in Google Maps",
      photos: "Their photos",
    },
    form: {
      title: "Your quote",
      intro: "Say what your price covers, then the total. You check it all before it is sent.",
      included: "What's included",
      labourOnly: "Labour only",
      labourAndMaterials: "Labour and materials",
      coversLabel: "What your price covers",
      coversPlaceholder: "e.g. Supply and fit a new 3-seater sofa and take the old one away",
      total: "Total price",
      totalTax: "incl. all taxes",
      totalHelp: "Include VAT and any other taxes: this is what the client pays.",
      warranty: "Warranty",
      warrantyNone: "None",
      warranty3: "3 months",
      warranty6: "6 months",
      warranty12: "12 months",
      warrantyPlaceholder: "Or your own, e.g. 2 years on parts",
      takes: "How long it takes",
      when: "When you could do it",
      earliest: "Earliest start",
      finishBy: "Finish by",
      files: "Photos or documents",
      note: "Note to the client (optional)",
      notePlaceholder: "Anything else they should know",
      review: "Review and send",
      needPrice: "Add your total price to continue.",
      cantQuote: "Can't quote this job",
    },
    review: {
      title: "Send this quote?",
      subtitle: "To {{name}}",
      subtitleNoName: "To the client",
      total: "Total, incl. all taxes",
      includes: "Includes",
      warranty: "Warranty",
      takes: "Takes",
      available: "Available",
      files: "Attachments",
      filesCount: "{{n}} attached",
      note: "Note",
      send: "Send quote",
      change: "Change something",
      from: "From {{date}}",
      until: "Until {{date}}",
    },
    declineSheet: {
      title: "Can't quote this job?",
      subtitle: "Tell {{name}} why. They see your reason.",
      subtitleNoName: "Tell the client why. They see your reason.",
      reasonLabel: "Why not?",
      no_availability: "No availability",
      outside_area: "Outside my area",
      not_my_work: "Not work I do",
      budget_or_timing: "The budget or timing doesn't work",
      other: "Something else",
      noteLabel: "Anything to add (optional)",
      noteLabelOther: "Tell them why",
      notePlaceholder: "e.g. Fully booked until December",
      send: "Decline to quote",
      chooseReason: "Choose a reason to continue.",
    },
    jobFallback: 'Job',
    loadFailed: 'This quote request did not load. Check your connection and try again.',
    contextLoadFailed: 'The details of this quote request did not load. Check your connection and try again.',
    notFound: "We couldn't find this quote request, or it has already been answered.",
    alreadySent: 'You have already sent a quote for this request.',
    alreadyDeclined: 'You declined this quote request.',
    closedBody: 'This quote request is closed. The client has picked a quote, the deadline has passed, or the request was withdrawn.',
    deadlinePassed: 'The deadline for this request was {{date}}, so the client can no longer take a quote.',
    addNotesFirstTitle: 'Add notes first',
    addNotesFirstBody: 'Type or dictate notes, then tap Rewrite.',
    rewriteFailedTitle: 'Could not rewrite notes',
    rewriteFailedBody: 'Please try again.',
    enterPriceTitle: 'Enter your price',
    enterPriceBody: 'Type the total price for this work, then tap Submit quote.',
    durationTitle: 'Check the time estimate',
    durationBody: 'Enter a number greater than zero, or leave it blank.',
    durationPlaceholder: 'e.g. 2',
    unit: {
      hours: 'Hours',
      days: 'Days',
      weeks: 'Weeks',
    },
    dictate: 'Dictate',
    stop: 'Stop',
    rewrite: 'Rewrite',
    rewriting: 'Rewriting…',
    submit: 'Submit quote',
    submitting: 'Submitting…',
    sent: "Quote sent. We'll tell you if the client accepts it.",
    sendFailedTitle: "Couldn't send your quote",
    sendFailedBody: 'Your quote was not sent. Your entries are still here, so try again in a moment.',
    offlineSend: "You're offline. Your quote is kept on this device, so send it when you're back online.",
    declineConfirmTitle: 'Decline this request?',
    declineConfirmBody: "The client will be told you won't quote.",
    cancel: 'Cancel',
    decline: 'Decline',
    declined: 'Request declined. The client has been told.',
    declineFailedTitle: "Couldn't decline",
    declineFailedBody: 'The request was not declined. Try again in a moment.',
    offlineDecline: "You're offline. Decline the request when you're back online.",
  },
  /** inviteContactToJob returned notTold: the contractor has no email and no account. */
  contractorNotTold: {
    title: 'Nobody was told',
    body: "{{name}} is assigned but has no email, so they haven't been told. Add their email, then assign again.",
  },
  created: {
    assignNow_other: "Assign them now",
    assignNow_one: "Assign it now",
    subtitleAssignedTo: "In Work and assigned to {{names}}.",
    subtitleAssigned: "In Work and assigned.",
    changeWho: "Change who does it",
    subtitleSolo_other: "They’re in Work and assigned to you.",
    subtitleSolo_one: "It’s in Work and assigned to you.",
    subtitle_other: "They’re in Work and unassigned. Nobody has been told yet.",
    subtitle_one: "It’s in Work and unassigned. Nobody has been told yet.",
    title_one: 'Created {{count}} job',
    title_other: 'Created {{count}} jobs',
    subtitle: "They’re in Work and unassigned. Nobody has been told yet.",
    listTitle: 'Created jobs',
    jobLink: 'Job {{shortId}}',
    backToRequest: 'Back to the request',
    backToAsset: 'Back to asset',
    backToJobs: 'Back to jobs',
    technicalTitle: 'Technical details',
    technicalSummary: 'Full job and asset identifiers for support or integrations.',
    technicalJobIds: 'Job IDs',
    technicalAssetId: 'Asset ID',
    showMore: 'Show more',
    showLess: 'Show less',
  },
  jobTags: {
    urgency: {
      low: 'Low priority',
      medium: 'Medium priority',
      high: 'High priority',
      urgent: 'Urgent',
      critical: 'Critical',
    },
    visibility: {
      private: 'Private',
      team: 'Team',
      public: 'Public',
    },
  },
  assigneeSuggestion: {
    similarCompleted_one: "{{count}} similar completed job",
    similarCompleted_other: "{{count}} similar completed jobs",
    skillMatches_one: "{{count}} job with matching required skills",
    skillMatches_other: "{{count}} jobs with matching required skills",
    completedOnAsset_one: "{{count}} completed on this asset",
    completedOnAsset_other: "{{count}} completed on this asset",
    activeAssignments_one: "{{count}} active assignment",
    activeAssignments_other: "{{count}} active assignments",
    overdue_one: "{{count}} overdue",
    overdue_other: "{{count}} overdue",
    separator: ", ",
  },
  quoteComparisonCopy: {
    materialsIncluded: "Materials included; no exclusions stated",
    materialsExcluded: "Materials excluded: {{details}}",
    materialsMissing: "Materials excluded; details missing",
    evidenceAttachments_one: "{{count}} evidence attachment",
    evidenceAttachments_other: "{{count}} evidence attachments",
    noEvidence: "No evidence attached",
    missingScope: "what the price covers",
    missingTiming: "timing",
    durationHours_one: "{{count}} hour",
    durationHours_other: "{{count}} hours",
    durationDays_one: "{{count}} day",
    durationDays_other: "{{count}} days",
    durationWeeks_one: "{{count}} week",
    durationWeeks_other: "{{count}} weeks",
  },
} as const;
